import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaRupeeSign } from "react-icons/fa";
import axios from "axios";
import Select from 'react-select';
import { toast } from "react-toastify";
import defaultImg from "./../../../images/task/img1.jpg";
import { var_api, image_api } from "../../../constant";
import { Modal } from "react-bootstrap";
import { set } from "date-fns";



const Icon = ({ name, size = 20 }) => {
  

  // small set of inline SVGs used in sidebar/topbar
  const common = { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" };
  switch (name) {
    case "menu":
      return (
        <svg {...common}><path d="M3 6h18M3 12h18M3 18h18" stroke="#333" strokeWidth="1.6" strokeLinecap="round"/></svg>
      );
    case "home":
      return (
        <svg {...common}><path d="M3 11.5L12 4l9 7.5" stroke="#333" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M5 21V12h14v9" stroke="#333" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>
      );
    case "customers":
      return (
        <svg {...common}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="#333" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><circle cx="12" cy="7" r="4" stroke="#333" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>
      );
    case "tables":
      return (
        <svg {...common}><rect x="3" y="4" width="18" height="6" rx="2" stroke="#333" strokeWidth="1.4"/><path d="M8 14v6M16 14v6" stroke="#333" strokeWidth="1.4" strokeLinecap="round"/></svg>
      );
    case "bills":
      return (
        <svg {...common}><path d="M7 3h10l4 4v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h3z" stroke="#333" strokeWidth="1.2" fill="none"/><path d="M8 10h8M8 14h8" stroke="#333" strokeWidth="1.2" strokeLinecap="round"/></svg>
      );
    case "reports":
      return (
        <svg {...common}><path d="M3 3v18h18" stroke="#333" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M21 8l-6 6-4-4-6 6" stroke="#333" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/></svg>
      );
    case "settings":
      return (
        <svg {...common}><path d="M12 15.5A3.5 3.5 0 1 0 12 8.5a3.5 3.5 0 0 0 0 7z" stroke="#333" strokeWidth="1.2" fill="none"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06A2 2 0 0 1 2.28 17.9l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82L4.31 4.28A2 2 0 0 1 7.14 1.45l.06.06a1.65 1.65 0 0 0 1.82.33h.01A1.65 1.65 0 0 0 10 2.4V2a2 2 0 0 1 4 0v.4c.07.59.39 1.13.91 1.51.56.42 1.2.39 1.82-.33l.06-.06A2 2 0 0 1 21.72 6.1l-.06.06a1.65 1.65 0 0 0-.33 1.82v.01c.38.52 1 1 1.51 1.07H22a2 2 0 0 1 0 4h-.4c-.59.07-1.13.39-1.51.91z" stroke="#333" strokeWidth="0.9" fill="none"/></svg>
      );
    case "logout":
      return (
        <svg {...common}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="#333" strokeWidth="1.4"/><path d="M16 17l5-5-5-5" stroke="#333" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/><path d="M21 12H9" stroke="#333" strokeWidth="1.4" strokeLinecap="round"/></svg>
      );
    case "search":
      return (
        <svg {...common}><circle cx="11" cy="11" r="6" stroke="#666" strokeWidth="1.2"/><path d="M21 21l-4.35-4.35" stroke="#666" strokeWidth="1.2" strokeLinecap="round"/></svg>
      );
    default:
      return null;
  }
};


const sampleProducts = [
  { id: 1, name: "Schezwan Egg Noodles", price: 24, img: "https://i.imgur.com/3O4kG9b.jpg" },
  { id: 2, name: "Spicy Shrimp Soup", price: 40, img: "https://i.imgur.com/0jKZ3K1.jpg" },
  { id: 3, name: "Thai Style Fried Noodles", price: 40, img: "https://i.imgur.com/muJHqCX.jpg" },
  { id: 4, name: "Chinese Prawn Spaghetti", price: 24, img: "https://i.imgur.com/dt8YvJd.jpg" },
  { id: 5, name: "Chilli Garlic Thai Noodles", price: 24, img: "https://i.imgur.com/LAGkRDN.jpg" },
  { id: 6, name: "Japanese Soba Noodles", price: 30, img: "https://i.imgur.com/hxCUpBz.jpg" },
  { id: 7, name: "Veg Manchurian", price: 18, img: "https://i.imgur.com/A0Z9m3c.jpg" },
  { id: 8, name: "Spring Rolls", price: 12, img: "https://i.imgur.com/5QXgL6F.jpg" },
  { id: 9, name: "Fried Rice", price: 22, img: "https://i.imgur.com/8Qw6V1J.jpg" },
    { id: 4, name: "Chinese Prawn Spaghetti", price: 24, img: "https://i.imgur.com/dt8YvJd.jpg" },

];

const WarehousePOS = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState("Lunch");
  const [cart, setCart] = useState([]);
  const [extraDiscount, setExtraDiscount] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [customerPhoneSearch, setCustomerPhoneSearch] = useState("");
  const [newCustomerName, setNewCustomerName] = useState("");
  const [dob, setDob] = useState("");
const [anniversary, setAnniversary] = useState("");
const [fullAddress, setFullAddress] = useState("");
const [remarks, setRemarks] = useState("");

  const [paymodeOptions, setPaymodeOptions] = useState([]);
  const [cuttingStyles, setCuttingStyles] = useState([]);
  const [showCuttingModal, setShowCuttingModal] = useState(false);
  const [cuttingForProduct, setCuttingForProduct] = useState(null);
  const [showCreateCustomerModal, setShowCreateCustomerModal] = useState(false);
  const categories = ["Starters", "Breakfast", "Lunch", "Supper", "Desserts", "Beverages"];
const [categoryData, setCategoryData] = useState([]);
const [billData, setBillData] = useState(null);
const [showBillModal, setShowBillModal] = useState(false);

const [showHoldOrdersModal, setShowHoldOrdersModal] = useState(false);
const [holdOrders, setHoldOrders] = useState([]);
const [loadingHoldOrders, setLoadingHoldOrders] = useState(false);
const [currentHoldOrderId, setCurrentHoldOrderId] = useState(null);
const [showCuttingSlipModal, setShowCuttingSlipModal] = useState(false);
const [cuttingSlipData, setCuttingSlipData] = useState(null);
const [cuttingInstructions, setCuttingInstructions] = useState({});
const [deliveryCharge, setDeliveryCharge] = useState(null);

const [cleaningCharge, setCleaningCharge] = useState(null);

const [initialLoading, setInitialLoading] = useState(false);
  const toggleSidebar = () => setSidebarCollapsed((v) => !v);

    const [showSubModal, setShowSubModal] = useState(false);
    const [subscriptionData, setSubscriptionData] = useState(null);
    const [paying, setPaying] = useState(false);
    const [subMessageOnly, setSubMessageOnly] = useState(false);
    const [searchText, setSearchText] = useState("");

    const [showPaymodeModal, setShowPaymodeModal] = useState(false);
const [currentOrderInfo, setCurrentOrderInfo] = useState(null);
const [paymodeEntries, setPaymodeEntries] = useState([
  { paymode_id: "", amount: "" }
]);


useEffect(() => {
  if (showPaymodeModal && paymodeOptions.length) {
    setPaymodeEntries(
      paymodeOptions.map(pm => ({
        paymode_id: pm.value,
        paymode_name: pm.label,
        amount: ""
      }))
    );
  }
}, [showPaymodeModal, paymodeOptions]);



  const qtyBtnCompact = (color) => ({
  border: "1px solid #ddd",
  background: "#fff",
  color,
  width: 26,
  height: 26,
  borderRadius: 4,
  fontSize: 16,
  fontWeight: 800,
  cursor: "pointer",
  lineHeight: "24px",
  marginLeft: 5
});

const actionBtn = (color) => ({
  border: "1px solid #ddd",
  background: "#fff",
  color,
  padding: "4px 6px",
  fontSize: 11,
  borderRadius: 4,
  cursor: "pointer",
});




// ✅ REPLACE this addToCart function (around line 95)
// ✅ FIXED addToCart function - properly handles prices

const addToCart = (product, variant = null, cutting = null) => {
  setCart((cur) => {
    // ✅ Handle both regular products and Cold Cut variants
    const isColdCutVariant = product.variant_name && product.variant_image !== undefined;
    const baseId = isColdCutVariant ? product.product_id : (product.product_id || product.id || product.veemart_product_id);
    const variantId = isColdCutVariant ? product.id : (variant?.id || null);
    
    const cuttingId = cutting?.id || cutting?.cut_id || null;
    const uniqueId = cuttingId ? `${baseId}-${cuttingId}` : variantId ? `${baseId}-${variantId}` : `${baseId}`;
    
    const found = cur.find((c) => c.uniqueId === uniqueId);
    
    if (found) {
      return cur.map((c) =>
        c.uniqueId === uniqueId ? { ...c, qty: c.qty + 1 } : c
      );
    }
    
    // ✅ Use correct field names for Cold Cut variants
    const displayName = isColdCutVariant ? product.variant_name : product.product_name;
    
    // ✅ FIXED: Proper price extraction with multiple fallbacks
    let sellingPrice = 0;
    if (isColdCutVariant) {
      sellingPrice = product.final_selling_price || product.unit_price || product.price || 0;
    } else {
      sellingPrice = product.final_selling_price || product.unit_price || product.price || 0;
    }
    
    const unitPrice = product.unit_price || product.final_selling_price || product.price || 0;
    const businessProfit = product.business_profit || null;
    
    console.log('Adding to cart:', {
      product_name: displayName,
      final_selling_price: sellingPrice,
      unit_price: unitPrice,
      cutting: cutting?.cutting_name || 'No cutting'
    });
    
    return [...cur, {
      product_id: baseId,
      product_name: displayName || product.name,
      final_selling_price: Number(sellingPrice),
      unit_price: Number(unitPrice),
      business_profit: businessProfit,
      product_image: isColdCutVariant ? product.variant_image : product.product_image,
      uniqueId,
      id: uniqueId,
      variant_id: variantId,
      variant_name: isColdCutVariant ? product.variant_name : (variant?.name || null),
      cutting_id: cuttingId,
      cutting_name: cutting?.cutting_name || cutting?.cut_name || cutting?.name || null,
      cutting_image: cutting?.cutting_image || null,
      cutting_code: cutting?.cutting_code || cutting?.code || cutting?.cut_code || null,
      cutting_info: cutting?.cutting_info || cutting?.instructions || '',
      gross_weight: product.gross_weight || null,
      uom: product.uom || null,
      qty: null,
    }];
  });
};

  const updateQty = (id, qty) => {
    if (qty < 1) qty = 1;
    setCart((cur) => cur.map((c) => (c.id === id ? { ...c, qty } : c)));
  };

  // per-item discount removed

  const removeItem = (id) => setCart((cur) => cur.filter((c) => c.id !== id));

  // calculations
  const subtotal = Object.values(
  cart.reduce((acc, item) => {
    // ❌ Skip cutting items
    if (item.cutting_id) return acc;

    const key = item.product_id;

    if (!acc[key]) {
      acc[key] = {
        price: Number(item.final_selling_price || item.price || 0),
        qty: 0,
      };
    }

    acc[key].qty += Number(item.qty || 0);

    return acc;
  }, {})
).reduce((sum, product) => {
  return sum + product.price * product.qty;
}, 0);



  // const subtotal = cart.reduce((s, it) => s + (Number(it.final_selling_price || it.price || 0) * Number(it.qty || 0)), 0);
  const tax = subtotal * 0.12; // 12% as example (adjust if needed)
  // const payable = Math.max(0, subtotal + tax - (Number(extraDiscount) || 0));
  const payable = Math.max(0, subtotal + (Number(deliveryCharge) || 0) + (Number(cleaningCharge) || 0) - (Number(extraDiscount) || 0));

const fetchCustomers = async () => {
  try {
    const res = await axios.get(`${var_api}veemart_instore_customers/get`);
    const data = Array.isArray(res.data) ? res.data : res.data?.data || res.data || [];
    setCustomers(data || []);
  } catch (err) {
    console.error("Failed to fetch customers", err);
  }
};

const fetchPaymodes = async () => {
  try {
    const res = await axios.get(`${var_api}paymode_master/get-warehouseid-active/${warehouse_id}`);
    const data = Array.isArray(res.data) ? res.data : res.data?.data || res.data || [];
    setPaymodeOptions(data.map((p) => ({ value: p.id, label: p.paymode_name, raw: p })));
  } catch (err) {
    console.error("Failed to fetch paymodes", err);
  }
};

const fetchCuttingStyles = async (productId) => {
  try {
    // Use the meat cutting instructions endpoint
    const res = await axios.get(`${var_api}veemart_meat_cutting_instructions/getcuttingbyProductid/${productId}`);
    const data = Array.isArray(res.data) ? res.data : res.data?.data || res.data || [];
    // normalize items (some APIs wrap in {data: [...]})
    const normalized = Array.isArray(data) ? data : [];
    setCuttingStyles(normalized || []);
  } catch (err) {
    console.error("Failed to fetch cutting styles", err);
  }
};




// ✅ FRONTEND - Replace handleCheckout function (around line 170)
const handleCheckout = async () => {
  try {
    if (cart.length === 0) {
      toast.warn("No items in the cart!");
      return;
    }

    if (!selectedCustomer?.id) {
      // toast.warn("Please select a customer before checkout.");
      // return;
     
       setShowCreateCustomerModal(true);
       setNewCustomerName("");
        
       return; // ⛔ IMPORTANT
    } 

     // ✅ Customer exists → continue
    await continueCheckoutAfterCustomer();

    // ✅ Check if any items have cutting styles
    // const itemsWithCutting = cart.filter(item => item.cutting_id && item.cutting_name);
    
    // if (itemsWithCutting.length > 0) {
    //   // ✅ Generate cutting slip data
    //   const slipData = prepareCuttingSlipData();
    //   setCuttingSlipData(slipData);
    //   setShowCuttingSlipModal(true);
    //   return; // Stop here, user will confirm from modal
    // }
    
    // // If no cutting items, proceed directly
    // await processBilling();

  } catch (err) {
    console.error("❌ Checkout Error:", err);
    toast.error(`❌ Checkout failed: ${err.message}`);
  }
};


const continueCheckoutAfterCustomer = async () => {
  // ✅ Check if any items have cutting styles
  // const itemsWithCutting = cart.filter(
  //   item => item.cutting_id && item.cutting_name
  // );

   const hasAnyCutting = cart.some(item => item.cutting_id);

  // if (itemsWithCutting.length > 0) {
    if (hasAnyCutting) {
    const slipData = prepareCuttingSlipData();
    setCuttingSlipData(slipData);
    setShowCuttingSlipModal(true);
    return;
  }

  // No cutting → proceed
  await processBilling();
};



const handlePrintCuttingSlip = () => {
  const printContents = document.getElementById("cutting-slip-print").innerHTML;

  const printWindow = window.open("", "_blank", "width=600,height=800");

  printWindow.document.write(`
    <html>
      <head>
        <title>Cutting Slip</title>
        <style>
          @page { size: auto; margin: 10mm; }
          body { font-family: Arial, sans-serif; font-size: 12px; }
          table { width: 100%; border-collapse: collapse; }
          th, td { padding: 6px; }
          
        @media print {
          .hide-on-print {
            display: none !important;
          }
        }
        </style>
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();

  // Chrome print
  printWindow.print();
  printWindow.close();
};


// const handlePrintCuttingSlip = async () => {
//   try {
//     if (!cuttingSlipData || !cuttingSlipData.items || cuttingSlipData.items.length === 0) {
//       toast.error('No cutting slip data available');
//       return;
//     }

//     const printerName = "POS-80C"; // Your thermal printer name

//     const payload = {
//       printer_name: printerName,
//       cutting_slip_data: {
//         ...cuttingSlipData,
//         prepared_by: localStorage.getItem("user_name") || "Admin"
//       }
//     };

//     const res = await axios.post(
//       `${var_api}veemart_instore_pos_billing/print-cutting-slip`,
//       payload
//     );

//     if (res.status === 200) {
//       toast.success('✅ Cutting slip sent to printer!');
//     }
//   } catch (err) {
//     console.error('Print cutting slip error:', err);
//     const errorMsg = err.response?.data?.details || err.message || 'Print failed';
//     toast.error(`❌ Print failed: ${errorMsg}`);
//   }
// };

// const prepareCuttingSlipData = () => {
//   const billNumber = `BILL-${Date.now()}`;
//   const items = [];
  
//   cart.forEach(item => {
//     if (item.cutting_id && item.cutting_name) {
//       items.push({
//         product_id: item.product_id,
//         product_name: item.product_name,
//         gross_weight: item.gross_weight,
//         uom: item.uom,
//         cutting_id: item.cutting_id,
//         cutting_name: item.cutting_name,
//         cutting_code: item.cutting_code || '',
//         cutting_image: item.cutting_image,
//         cutting_info: item.cutting_info || '', // ✅ Added
//         qty: Number(item.qty || 0)
//       });
//     }
//   });
  
//   return {
//     bill_number: billNumber,
//     customer_name: selectedCustomer?.name || 'Walk-in',
//     customer_mobile: selectedCustomer?.mobile || '',
//     date_time: new Date().toLocaleString('en-GB'),
//     warehouse: localStorage.getItem("warehouse_name") || localStorage.getItem("warehouse_no") || "N/A",
//     items: items
//   };
// };

const prepareCuttingSlipData = () => {
  const billNumber = `BILL-${Date.now()}`;

  // 🔹 Group cart items by product_id
  const productMap = {};

  cart.forEach(item => {
    if (!productMap[item.product_id]) {
      productMap[item.product_id] = {
        product_name: item.product_name,
        baseItem: null,
        cuttingItems: []
      };
    }

    if (item.cutting_id) {
      // ✅ Cutting item
      productMap[item.product_id].cuttingItems.push({
        product_name: item.product_name,
        cutting_code: item.cutting_code,
        cutting_name: item.cutting_name,
        cutting_info: item.cutting_info || "-",
        qty: Number(item.qty || 0)
      });
    } else {
      // ✅ Base (no cutting)
      productMap[item.product_id].baseItem = {
        product_name: item.product_name,
        qty: Number(item.qty || 0)
      };
    }
  });

  // 🔹 Build final slip items
  const items = [];

  Object.values(productMap).forEach(p => {
    if (p.cuttingItems.length > 0) {
      // ✅ If cutting exists → show ONLY cuttings
      p.cuttingItems.forEach(cut => items.push(cut));
    } else if (p.baseItem) {
      // ✅ No cutting → show base item with Code 0
      items.push({
        product_name: p.baseItem.product_name,
        cutting_code: 0,
        cutting_name: "",
        cutting_info: "-",
        qty: p.baseItem.qty
      });
    }
  });

  return {
    bill_number: billNumber,
    customer_name: selectedCustomer?.name || "Walk-in",
    customer_mobile: selectedCustomer?.mobile || "",
    date_time: new Date().toLocaleString("en-GB"),
    warehouse:
      localStorage.getItem("warehouse_name") ||
      localStorage.getItem("warehouse_no") ||
      "N/A",
    items
  };
};


const processBilling = async () => {
  try {
    // 🆕 Check if completing a hold order
    if (currentHoldOrderId) {
      console.log("🔄 Completing Hold Order ID:", currentHoldOrderId);
      
      const res = await axios.post(
        `${var_api}veemart_instore_pos_billing/complete-hold-order/${currentHoldOrderId}`,
        { payment_mode: paymentMode }
      );

      if (res.status === 200 || res.status === 201) {
        toast.success("✅ Hold order completed successfully!");
        
        const billingId = res.data.billingId;
        
        if (billingId) {
          try {
            const billRes = await axios.get(
              `${var_api}veemart_instore_pos_billing/billing-detail/${billingId}`
            );
            
            if (billRes.status === 200) {
              console.log("billRes:", billRes.data);
              setBillData(billRes.data);
              setShowBillModal(true);
            }
          } catch (fetchErr) {
            console.error("⚠️ Failed to fetch bill details:", fetchErr);
            toast.warning("Order completed but unable to show preview");
          }
        }

        setCart([]);
        setExtraDiscount(0);
        setCleaningCharge(0);
        setRemarks("");
        setSelectedCustomer(null);
        setCustomerPhoneSearch("");
        setCurrentHoldOrderId(null);
        
        toast.info("Cart cleared. Ready for next order.");
      }
      
      return;
    }

    // Normal checkout
   // Normal checkout
    console.log("🛒 Starting Normal Checkout Process...");

    // ✅ FIXED: Separate items with cutting and without cutting
    const billingDetails = [];
    const groupedProducts = {};
    
    cart.forEach(item => {
      const productKey = item.product_id;
      
      // ✅ If item has NO cutting, add it as separate entry
      if (!item.cutting_id) {
        billingDetails.push({
          warehouse_id: Number(localStorage.getItem("warehouse_id")) || 1,
          product_id: item.product_id,
          variant_id: item.variant_id || null,
          qty: Number(item.qty || 0),
          final_selling_price: Number(item.final_selling_price || item.price || 0),
          unit_price: Number( item.final_selling_price || item.price || 0),
          business_profit: item.business_profit || null,
          discount_percent: 0,
          tax_percent: 12,
          total: Number((Number(item.final_selling_price || item.price || 0) * Number(item.qty || 0)).toFixed(2)),
          remarks: "",
          cuttings: [] // ✅ Empty array for items without cutting
        });
      } else {
        // ✅ Group items WITH cutting by product_id
        if (!groupedProducts[productKey]) {
          groupedProducts[productKey] = {
            warehouse_id: Number(localStorage.getItem("warehouse_id")) || 1,
            product_id: item.product_id,
            product_name: item.product_name,
            final_selling_price: Number(item.final_selling_price || item.price || 0),
            unit_price: Number(item.unit_price || item.final_selling_price || item.price || 0),
            business_profit: item.business_profit || null,
            variant_id: item.variant_id || null,
            discount_percent: 0,
            tax_percent: 12,
            remarks: "",
            total_qty: 0,
            total_amount: 0,
            cuttings: []
          };
        }
        
        groupedProducts[productKey].total_qty += Number(item.qty || 0);
        const itemTotal = Number(item.final_selling_price || item.price || 0) * Number(item.qty || 0);
        groupedProducts[productKey].total_amount += itemTotal;
        
        groupedProducts[productKey].cuttings.push({
          cutting_id: item.cutting_id,
          cutting_name: item.cutting_name,
          cutting_code: item.cutting_code || "",
          cutting_info: item.cutting_info || "",
          qty: Number(item.qty || 0)
        });
      }
    });

    // ✅ Add grouped cutting items to billingDetails
   Object.values(groupedProducts).forEach(product => {
  const existingIndex = billingDetails.findIndex(
    item =>
      item.product_id === product.product_id &&
      item.variant_id === product.variant_id
  );

  if (existingIndex !== -1) {
    // ✅ MERGE with existing product
    // billingDetails[existingIndex].qty += product.total_qty;
    billingDetails[existingIndex].total += Number(product.total_amount.toFixed(2));

    // merge cuttings
    billingDetails[existingIndex].cuttings = [
      ...(billingDetails[existingIndex].cuttings || []),
      ...(product.cuttings || [])
    ];
  } else {
    // ✅ ADD only if not exists
    billingDetails.push({
      warehouse_id: product.warehouse_id,
      product_id: product.product_id,
      variant_id: product.variant_id,
      qty: product.total_qty,
      final_selling_price: product.final_selling_price,
      unit_price: product.final_selling_price,
      business_profit: product.business_profit,
      discount_percent: product.discount_percent,
      tax_percent: product.tax_percent,
      total: Number(product.total_amount.toFixed(2)),
      remarks: product.remarks,
      cuttings: product.cuttings || []
    });
  }
});


    const totalItems = billingDetails.length;
    const totalQty = billingDetails.reduce((sum, p) => sum + p.qty, 0);

    

    const payload = {
      warehouse_id: Number(localStorage.getItem("warehouse_id")) || 1,
      bill_number: cuttingSlipData?.bill_number || `BILL-${Date.now()}`,
      bill_date_time: new Date().toISOString().slice(0, 19).replace("T", " "),
      customer_id: selectedCustomer?.id,
      customer_mobile: selectedCustomer?.mobile || customerPhoneSearch,
      customer_name: selectedCustomer?.name || newCustomerName || "Walk-in",
      total_items: totalItems,
      total_qty: totalQty,
      sub_total: Number(subtotal?.toFixed(2)),
      discount_amount: Number(extraDiscount || 0),
      cleaning_charge: Number(cleaningCharge || 0),
      delivery_charge: Number(deliveryCharge || 0),
      tax_amount: Number(tax.toFixed(2)),
      grand_total: Number(payable.toFixed(2)),
      payment_status: 1, // 1 = Paid
      payment_mode: paymentMode || "Cash",
      remarks: remarks?.trim() || "",
      created_by: localStorage.getItem("login_id") || "Admin",
      order_status: 1,
      billing_details: billingDetails
    };

    const res = await axios.post(`${var_api}veemart_instore_pos_billing/post`, payload);

    if (res.status === 200 || res.status === 201) {
      toast.success("✅ Bill generated successfully!");
      
      const billingId = res.data.insertedId || res.data.id;

      if (billingId) {

         setCurrentOrderInfo({
    order_id: billingId,
    customer_name: selectedCustomer?.name || "Walk-in",
    customer_mobile: selectedCustomer?.mobile || customerPhoneSearch,
    grand_total: Number(payable.toFixed(2))
  });

  setPaymodeEntries([{ paymode_id: "", amount: "" }]);
  setShowPaymodeModal(true);

       
      }

      setCart([]);
      setExtraDiscount(null);
      setCleaningCharge(null);
      setDeliveryCharge(null);
      setRemarks("");
      setSelectedCustomer(null);
      setCustomerPhoneSearch("");
      
      toast.info("Cart cleared. Ready for next order.");
    }

  } catch (err) {
    console.error("❌ Billing Error:", err);
    const errorMsg = err.response?.data?.details || 
                     err.response?.data?.error || 
                     err.message || 
                     "Billing failed. Please try again.";
    
    toast.error(`❌ Billing failed: ${errorMsg}`);
  }
};



const [paymentMode, setPaymentMode] = useState("Cash");
const [selectedCustomer, setSelectedCustomer] = useState(null);
const [searchResults, setSearchResults] = useState([]);
const [searchLoading, setSearchLoading] = useState(false);


const [productData, setProductData] = useState([]);
const [variantData, setVariantData] = useState([]);
const [selectedProduct, setSelectedProduct] = useState(null);
const [selectedCategory, setSelectedCategory] = useState(null);

console.log("cart", cart);

useEffect(() => {
  const loadInitialData = async () => {
    const warehouse_id =localStorage.getItem("warehouse_id");
    try {
      setInitialLoading(true);

      // 1️⃣ Fetch categories
      const categoryRes = await axios.get(`${var_api}sa_veemart_category_master/getactiveCategorybywarehouse/${warehouse_id}`);
      const categories = Array.isArray(categoryRes.data)
        ? categoryRes.data
        : categoryRes.data?.data || [];

      // 2️⃣ Add COLD CUT manually as the LAST category
      const coldCutCategory = {
        id: "cold-cut-manual",
        veemart_category_name: "Cold Cut",
      };

      const modifiedCategories = [...categories, coldCutCategory];

      setCategoryData(modifiedCategories);

      if (modifiedCategories.length === 0) return;

      // 3️⃣ Auto-select FIRST category (NOT Cold Cut)
      const firstCategory = modifiedCategories[0];
      setSelectedCategory(firstCategory);

      // 4️⃣ Fetch product list based on selected category
      let productRes;
      if (firstCategory.veemart_category_name.toLowerCase() === "cold cut") {
        productRes = await axios.get(`${var_api}sa_veemart_product_master/cold-cut-category/variants`);
      } else {
        productRes = await axios.get(
          `${var_api}sa_veemart_product_master/category/${firstCategory.id}`
        );
      }

      const products = Array.isArray(productRes.data)
        ? productRes.data
        : productRes.data?.data || [];

      setProductData(products);

      fetchPaymodes();
      fetchCustomers();
    } catch (error) {
      toast.error("Failed to load initial data");
      console.error("Initial Data Load Error:", error);
    } finally {
      setInitialLoading(false);
    }
  };

  loadInitialData();
  checkSubscriptionStatus();
}, []);




// set default payment mode when options load
useEffect(() => {
  if (paymodeOptions.length > 0 && (!paymentMode || paymentMode === 'Cash')) {
    setPaymentMode(paymodeOptions[0].value);
  }
}, [paymodeOptions]);

// Customer phone search / create
// Search customers using backend search endpoint
const searchCustomers = async (q) => {
  if (!q) {
    setSearchResults([]);
    return [];
  }
  try {
    setSearchLoading(true);
    const res = await axios.get(`${var_api}veemart_instore_customers/search-by-mobile`,
       {
        params: { search: q, warehouse_id: localStorage.getItem("warehouse_id") || 1 }
      }
    );
    const results = res.data?.results || [];
    setSearchResults(results || []);
    return results || [];
  } catch (err) {
    console.error('Customer search failed', err);
    setSearchResults([]);
    return [];
  } finally {
    setSearchLoading(false);
  }
};


// Auto search when user types 3 or more digits
useEffect(() => {
  const q = customerPhoneSearch?.trim();

  if (q && q.length >= 3) {
    searchCustomers(q);
  } else {
    setSearchResults([]); // clear dropdown if less than 3 digits
  }
}, [customerPhoneSearch]);


// Called when user clicks Search / Create
const handleCustomerPhoneSearch = async () => {
  if (!customerPhoneSearch) {
    toast.warning('Enter phone or search term');
    return;
  }
  const results = await searchCustomers(customerPhoneSearch);
  if (!results || results.length === 0) {
    setShowCreateCustomerModal(true);
  }
};

// Open the create-customer modal from the + Add Customer button
// with empty fields so user enters fresh phone and name
const openAddCustomerModal = () => {
  setNewCustomerName("");
  setCustomerPhoneSearch("");
  setShowCreateCustomerModal(true);
};

// Debounce: automatically search as user types (after 400ms)
useEffect(() => {
  const q = (customerPhoneSearch || '').trim();
  if (q.length < 2) {
    setSearchResults([]);
    return;
  }
  const t = setTimeout(() => searchCustomers(q), 400);
  return () => clearTimeout(t);
}, [customerPhoneSearch]);

// Clear selected customer when phone input is emptied or changed to a different number
useEffect(() => {
  const q = String(customerPhoneSearch || '').trim();
  if (!q) {
    if (selectedCustomer) setSelectedCustomer(null);
    return;
  }
    if (
    selectedCustomer &&
    !(
      selectedCustomer.mobile?.includes(q) ||
      selectedCustomer.name?.toLowerCase().includes(q.toLowerCase())
    )
  ) {
    setSelectedCustomer(null);
  }
}, [customerPhoneSearch]);

// When user selects from search results (accepts react-select option or id)

const selectCustomerFromSearch1= async (optionOrId) => {
  const id = optionOrId && typeof optionOrId === 'object' ? optionOrId.value : optionOrId;
  const found = (searchResults || []).find((s) => String(s.id) === String(id));
  if (!found) return;
  
  setSelectedCustomer({ 
    id: found.id, 
    name: found.customer_name || found.name, 
    mobile: found.customer_mobile_whatsapp || found.customer_mobile 
  });
  setNewCustomerName(found.customer_name || found.name || "");
  setCustomerPhoneSearch(found.customer_mobile_whatsapp || found.customer_mobile || '');
  setSearchResults([]);
  toast.info('Customer selected');
  
  // 🆕 Check for hold orders
  await fetchHoldOrders(found.id);
};


// Fetch hold orders for selected customer
const fetchHoldOrders = async (customerId) => {
  if (!customerId) return;
  
  try {
    setLoadingHoldOrders(true);
    const res = await axios.get(`${var_api}veemart_instore_pos_billing/hold-orders/${customerId}`);
    const orders = res.data?.data || [];
    
    if (orders.length > 0) {
      setHoldOrders(orders);
      setShowHoldOrdersModal(true);
      toast.info(`Found ${orders.length} hold order(s) for this customer`);
    } else {
      setHoldOrders([]);
    }
  } catch (err) {
    console.error('Failed to fetch hold orders:', err);
    setHoldOrders([]);
  } finally {
    setLoadingHoldOrders(false);
  }
};

// Load hold order into cart
// Load hold order into cart
const loadHoldOrder = (order) => {
  setCart([]);
  setCurrentHoldOrderId(order.id);
  
  const cartItems = [];
  
  order.details.forEach(detail => {
    // ✅ First, check if there are items WITH cutting
    if (detail.cuttings && detail.cuttings.length > 0) {
      detail.cuttings.forEach(cutting => {
        cartItems.push({
          product_id: detail.product_id,
          product_name: detail.product_name,
          final_selling_price: Number(detail.unit_price || 0),
          unit_price: Number(detail.unit_price || 0),
          business_profit: detail.business_profit || null,
          product_image: detail.product_image,
          uniqueId: `${detail.product_id}-${cutting.cutting_id}`,
          id: `${detail.product_id}-${cutting.cutting_id}`,
          variant_id: detail.variant_id || null,
          variant_name: null,
          cutting_id: cutting.cutting_id,
          cutting_name: cutting.cutting_name,
          cutting_code: cutting.cutting_code || null,
          cutting_info: cutting.cutting_info || "",
          gross_weight: detail.gross_weight || null,
          uom: detail.uom || null,
          qty: Number(cutting.qty || 0),
        });
      });
      
      // ✅ Calculate items WITHOUT cutting
      const totalCuttingQty = detail.cuttings.reduce((sum, c) => sum + Number(c.qty || 0), 0);
      const qtyWithoutCutting = Number(detail.qty || 0) - totalCuttingQty;
      
      // ✅ If there are items without cutting, add them separately
      if (qtyWithoutCutting > 0) {
        cartItems.push({
          product_id: detail.product_id,
          product_name: detail.product_name,
          final_selling_price: Number(detail.unit_price || 0),
          unit_price: Number(detail.unit_price || 0),
          business_profit: detail.business_profit || null,
          product_image: detail.product_image,
          uniqueId: `${detail.product_id}`,
          id: `${detail.product_id}`,
          variant_id: detail.variant_id || null,
          variant_name: null,
          cutting_id: null,
          cutting_name: null,
          cutting_code: null,
          cutting_info: "",
          gross_weight: detail.gross_weight || null,
          uom: detail.uom || null,
          qty: qtyWithoutCutting,
        });
      }
    } else {
      // ✅ If NO cuttings at all, add entire qty as item without cutting
      cartItems.push({
        product_id: detail.product_id,
        product_name: detail.product_name,
        final_selling_price: Number(detail.unit_price || 0),
        unit_price: Number(detail.unit_price || 0),
        business_profit: detail.business_profit || null,
        product_image: detail.product_image,
        uniqueId: `${detail.product_id}`,
        id: `${detail.product_id}`,
        variant_id: detail.variant_id || null,
        variant_name: null,
        cutting_id: null,
        cutting_name: null,
        cutting_code: null,
        cutting_info: "",
        gross_weight: detail.gross_weight || null,
        uom: detail.uom || null,
        qty: Number(detail.qty || 0),
      });
    }
  });
  
  setCart(cartItems);
  setExtraDiscount(Number(order.discount_amount || 0));
  setCleaningCharge(Number(order.cleaning_charge || 0));
  setRemarks(order.remarks || '');
  setPaymentMode(order.payment_mode || 'Cash');
  
  setShowHoldOrdersModal(false);
  toast.success('Hold order loaded into cart');
};



const handleOpenCuttingModal = (product) => {
  setCuttingForProduct(product);
  setShowCuttingModal(true);
};


const handleSubmitPaymode = async () => {

  const payload = paymodeEntries
    .filter(p => Number(p.amount) > 0 || Number(p.refund_amount) > 0)
    .map(p => ({
      order_id: currentOrderInfo.order_id,
      paymode_id: p.paymode_id,
      amount: Number(p.amount || 0),        // customer → owner
      balance_amount: Number(p.refund_amount || 0) // owner → customer
    }));

  if (payload.length === 0) {
    toast.error("Please enter payment");
    return;
  }

  try {
    await axios.post(`${var_api}order-paymode/post`, payload);
    toast.success("Payment settled successfully");

    setShowPaymodeModal(false);
    setCart([]);
    setExtraDiscount(null);
    setCleaningCharge(null);
    setDeliveryCharge(null);
    setRemarks("");
    setSelectedCustomer(null);
    setCustomerPhoneSearch("");

    await fetchBillDetails(currentOrderInfo.order_id);

  } catch (err) {
    console.error(err);
    toast.error("Failed to save payment");
  }
};





const fetchBillDetails = async (billingId) => {
   try {
          const billRes = await axios.get(
            `${var_api}veemart_instore_pos_billing/billing-detail/${billingId}`
          );
          
          if (billRes.status === 200) {
            console.log("billRes:", billRes.data);
            setBillData(billRes.data);
            setShowBillModal(true);
          }
        } catch (fetchErr) {
          console.error("⚠️ Failed to fetch bill details:", fetchErr);
          toast.warning("Bill created but unable to show preview");
        }
}




const handleSelectCuttingAndAdd = (cutting, qty = 1) => {
  if (!cuttingForProduct) return;
  
  const baseId = cuttingForProduct.product_id || cuttingForProduct.id || cuttingForProduct.veemart_product_id;
  const cuttingId = cutting.id || cutting.cut_id;
  
  // Check if this cutting already exists in cart for this product
  const existingItem = cart.find(item => 
    String(item.product_id) === String(baseId) && 
    String(item.cutting_id) === String(cuttingId)
  );
  
  if (existingItem) {
    // Update quantity
    setCart(cur => cur.map(item =>
      (String(item.product_id) === String(baseId) && 
       String(item.cutting_id) === String(cuttingId))
        ? { ...item, qty }
        : item
    ));
  } else {
    // Add new cutting variant
    addToCart(cuttingForProduct, null, cutting);
    setTimeout(() => {
      setCart(cur => cur.map(item =>
        (String(item.product_id) === String(baseId) && 
         String(item.cutting_id) === String(cuttingId))
          ? { ...item, qty }
          : item
      ));
    }, 50);
  }
};

// const handleRemoveCutting = () => {
//   if (!cuttingForProduct) return;
  
//   const baseId = cuttingForProduct.product_id || cuttingForProduct.id || cuttingForProduct.veemart_product_id;
  
//   setCart((cur) => cur.map((item) => {
//     if (String(item.product_id) === String(baseId) && item.cutting_id) {
//       return {
//         ...item,
//         cutting_id: null,
//         cutting_name: null,
//         cutting_image: null,
//         cutting_code: null
//       };
//     }
//     return item;
//   }));
  
//   setShowCuttingModal(false);
//   toast.info('Cutting style removed from product');
// };

// ============================================
// FINAL FIX: createCustomerFromModal with proper timing
// ============================================

const handleRemoveCutting = (cuttingItem) => {
  if (!cuttingItem) return;

  setCart((cur) =>
    cur.map((item) => {
      if (item.uniqueId === cuttingItem.uniqueId) {
        return {
          ...item,
          cutting_id: null,
          cutting_name: null,
          cutting_image: null,
          cutting_code: null
        };
      }
      return item;
    })
  );

  toast.info('Cutting style removed');
};


const createCustomerFromModal = async () => {
  if (!customerPhoneSearch) {
    toast.warning('Enter phone number');
    return;
  }
  
  const payload = {
    warehouse_id: Number(localStorage.getItem("warehouse_id")) || 1,
    customer_name: newCustomerName || `CUST-${Date.now()}`,
    customer_mobile_whatsapp: customerPhoneSearch,
    customer_dob: dob || null,
    customer_anniversary: anniversary || null,
    customer_full_address: fullAddress || null,
    remarks: remarks || null,
  };
  
  try {
    console.log('📤 Creating customer:', payload);
    
    const res = await axios.post(`${var_api}veemart_instore_customers/post`, payload);
    const created = res.data?.data || res.data || {};
    
    console.log('✅ Customer created response:', res.data);
    
    // ✅ Get customer ID - check all possible fields including insertedId
    const customerId = created.id || 
                       created.customer_id || 
                       created.insertId || 
                       created.insertedId ||  // ✅ Added this!
                       res.data.insertedId;   // ✅ Also check top level
    
    console.log('✅ Extracted customer ID:', customerId);
    
    if (!customerId) {
      console.error('❌ Invalid customer ID:', customerId);
      console.error('Full response:', res.data);
      toast.error('Failed to get valid customer ID from response');
      return;
    }
    
    // Convert to number
    const customerIdNum = Number(customerId);
    
    if (isNaN(customerIdNum) || customerIdNum <= 0) {
      console.error('❌ Invalid customer ID number:', customerIdNum);
      toast.error('Invalid customer ID received');
      return;
    }
    
    // ✅ Use the data from POST response directly
    const customerData = {
      id: customerIdNum,
      name: payload.customer_name,
      mobile: payload.customer_mobile_whatsapp
    };
    
    console.log('✅ Setting customer:', customerData);
  


    await handleCheckout();

    
    // Set the customer immediately
    setSelectedCustomer(customerData);
    setNewCustomerName(customerData.name);
    setCustomerPhoneSearch(customerData.mobile);
    
    // Close modal
    setShowCreateCustomerModal(false);
    
    // Clear form fields
    setDob("");
    setAnniversary("");
    setFullAddress("");
    setRemarks("");
    
    toast.success(`✅ Customer "${customerData.name}" created & selected!`);

    // ✅ Continue checkout AFTER state update
setTimeout(() => {
  continueCheckoutAfterCustomer();
}, 0);
    
    // ✅ Refresh customer list in background
    fetchCustomers().catch(err => console.error('Background fetch failed:', err));

    // ✅ Clear search results
    setSearchResults([]);
    
  } catch (err) {
    console.error('❌ Create customer failed:', err);
    console.error('Error response:', err.response?.data);
    const errorMsg = err.response?.data?.message || err.response?.data?.error || err.message;
    toast.error('Failed to create customer: ' + errorMsg);
  }
}; 



// ============================================

const handleHoldOrder = async () => {
  try {
    if (cart.length === 0) {
      toast.warn("No items in the cart!");
      return;
    }

    if (!selectedCustomer?.id) {
      toast.warn("Please select a customer before holding order.");
      return;
    }

    const customerId = Number(selectedCustomer.id);
    if (isNaN(customerId) || customerId <= 0) {
      console.error('❌ Invalid customer ID:', selectedCustomer.id);
      toast.error('Invalid customer selected. Please select again.');
      setSelectedCustomer(null);
      return;
    }

    console.log('🛒 Creating Hold Order for customer ID:', customerId);

    // ✅ FIXED: Separate items with cutting and without cutting
    const billingDetails = [];
    const groupedProducts = {};
    
    cart.forEach(item => {
      const productKey = item.product_id;
      
      // ✅ If item has NO cutting, add it as separate entry
      if (!item.cutting_id) {
        billingDetails.push({
          warehouse_id: Number(localStorage.getItem("warehouse_id")) || 1,
          product_id: item.product_id,
          variant_id: item.variant_id || null,
          qty: Number(item.qty || 0),
          final_selling_price: Number(item.final_selling_price || item.price || 0),
          unit_price: Number(item.unit_price || item.final_selling_price || item.price || 0),
          business_profit: item.business_profit || null,
          discount_percent: 0,
          tax_percent: 12,
          total: Number((Number(item.final_selling_price || item.price || 0) * Number(item.qty || 0)).toFixed(2)),
          remarks: "",
          cuttings: [] // ✅ Empty array for items without cutting
        });
      } else {
        // ✅ Group items WITH cutting by product_id
        if (!groupedProducts[productKey]) {
          groupedProducts[productKey] = {
            warehouse_id: Number(localStorage.getItem("warehouse_id")) || 1,
            product_id: item.product_id,
            product_name: item.product_name,
            final_selling_price: Number(item.final_selling_price || item.price || 0),
            unit_price: Number(item.unit_price || item.final_selling_price || item.price || 0),
            business_profit: item.business_profit || null,
            variant_id: item.variant_id || null,
            discount_percent: 0,
            tax_percent: 12,
            remarks: "",
            total_qty: 0,
            total_amount: 0,
            cuttings: []
          };
        }
        
        groupedProducts[productKey].total_qty += Number(item.qty || 0);
        const itemTotal = Number(item.final_selling_price || item.price || 0) * Number(item.qty || 0);
        groupedProducts[productKey].total_amount += itemTotal;
        
        groupedProducts[productKey].cuttings.push({
          cutting_id: item.cutting_id,
          cutting_name: item.cutting_name,
          cutting_code: item.cutting_code || "",
          cutting_info: item.cutting_info || "",
          qty: Number(item.qty || 0)
        });
      }
    });

    // ✅ Add grouped cutting items to billingDetails
    Object.values(groupedProducts).forEach(product => {
      billingDetails.push({
        warehouse_id: product.warehouse_id,
        product_id: product.product_id,
        variant_id: product.variant_id,
        qty: product.total_qty,
        final_selling_price: product.final_selling_price,
        unit_price: product.unit_price,
        business_profit: product.business_profit,
        discount_percent: product.discount_percent,
        tax_percent: product.tax_percent,
        total: Number(product.total_amount.toFixed(2)),
        remarks: product.remarks,
        cuttings: product.cuttings
      });
    });

    const totalItems = billingDetails.length;
    const totalQty = billingDetails.reduce((sum, p) => sum + p.qty, 0);

    // ... rest of the function stays the same
    const payload = {
      warehouse_id: Number(localStorage.getItem("warehouse_id")) || 1,
      customer_id: customerId,  // ✅ Use validated numeric ID
      customer_mobile: selectedCustomer.mobile || "",
      customer_name: selectedCustomer.name || "",
      total_items: totalItems,
      total_qty: totalQty,
      sub_total: Number(subtotal?.toFixed(2)),
      discount_amount: Number(extraDiscount || 0),
      cleaning_charge: Number(cleaningCharge || 0),
      tax_amount: Number(tax.toFixed(2)),
      grand_total: Number(payable.toFixed(2)),
      payment_status: 0,
      payment_mode: paymentMode || "Cash",
      remarks: remarks?.trim() || "",
      created_by:  localStorage.getItem("login_id") || "Admin",
      billing_details: billingDetails
    };

    console.log('📤 Hold Order Payload:', payload);

    const res = await axios.post(`${var_api}veemart_instore_pos_billing/hold-order`, payload);

    if (res.status === 200 || res.status === 201) {
      toast.success("✅ Order held successfully!");
      console.log('✅ Hold Order Success:', res.data);
      
      setCart([]);
      setExtraDiscount(0);
      setCleaningCharge(0);
      setRemarks("");
      setSelectedCustomer(null);
      setCustomerPhoneSearch("");
      setCurrentHoldOrderId(null);
      await fetchBillDetails(res.data.insertedId || res.data.id);
      
      toast.info("Order saved. Select customer to retrieve.");
    }

  } catch (err) {
    console.error("❌ Hold Order Error:", err);
    console.error("Error response:", err.response?.data);
    const errorMsg = err.response?.data?.details || err.message || "Failed to hold order";
    toast.error(`❌ ${errorMsg}`);
  }
};


// ============================================
// ALSO UPDATE selectCustomerFromSearch to handle properly
// ============================================

const selectCustomerFromSearch = async (optionOrId) => {
  const id = optionOrId && typeof optionOrId === 'object' ? optionOrId.value : optionOrId;
  const found = (searchResults || []).find((s) => String(s.id) === String(id));
  
  if (!found) {
    console.error('Customer not found in search results:', id);
    return;
  }
  
  const customerData = {
    id: found.id,
    name: found.customer_name || found.name,
    mobile: found.customer_mobile_whatsapp || found.customer_mobile
  };
  
  setSelectedCustomer(customerData);
  setNewCustomerName(customerData.name || "");
  setCustomerPhoneSearch(customerData.mobile || '');
  setSearchResults([]);
  
  toast.info('Customer selected');
  
  // Check for hold orders
  await fetchHoldOrders(customerData.id);
};

// When user clicks a category
const handleCategoryClick = async (category) => {
  try {
    setSelectedCategory(category);

    let productRes;

    // ✅ If Cold Cut category clicked → call special API
    if (
      category.veemart_category_name &&
      category.veemart_category_name.toLowerCase() === "cold cut"
    ) {
      productRes = await axios.get(
        `${var_api}sa_veemart_product_master/cold-cut-category/variants`
      );
    } else {
      // ✅ Other categories → default API
      productRes = await axios.get(
        `${var_api}sa_veemart_product_master/category/${category.id}`
      );
    }

    const products = Array.isArray(productRes.data)
      ? productRes.data
      : productRes.data?.data || [];

    setProductData(products);

  } catch (error) {
    console.error("Category click error:", error);
    toast.error("Failed to load products for category");
    setProductData([]);
  }
};



// Update your product click handler to handle variants
const handleProductClick = (product, variant = null) => {
  // Open cutting modal with option to skip
  // setCuttingForProduct(product);
   addToCart(product, null, null);
  // setShowCuttingModal(true);
}

  // inline styles (aiming to match image)
  const styles = {
    app: { display: "flex", height: "100vh", fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial" },
    sidebar: {
      width: sidebarCollapsed ? 72 : 220,
      background: "#ffffff",
      borderRight: "1px solid #e6e6e6",
      transition: "width 180ms ease",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    sideTop: { padding: 14 },
    logoBox: { display: "flex", alignItems: "center", gap: 10, padding: "6px 8px", marginBottom: 16 },
    logoSquare: { width: 40, height: 40, borderRadius: 8, background: "#ffc107", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 },
    iconRow: { display: "flex", flexDirection: "column", gap: 10, marginTop: 6 },
    smallIconWrap: { display: "flex", alignItems: "center", gap: 12, padding: "8px 10px", borderRadius: 8, cursor: "pointer" },
    topbar: { height: 64, background: "#fff", borderBottom: "1px solid #eaeaea", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 18px" },
    contentWrap: { display: "flex", flex: 1, overflow: "hidden" },
    leftPane: { flex: 2.1, padding: 18, overflowY: "auto", background: "#f6f7f9" },
    rightPane: { width: 420, background: "#fff", borderLeft: "1px solid #eaeaea", padding: 18, overflowY: "auto" },
    tabsRow: { display: "flex", gap: 10, marginBottom: 14, flexWrap: "wrap" },
    tabBtn: (active) => ({
      padding: "6px 14px",
      borderRadius: 20,
      border: active ? "none" : "1px solid #ddd",
      background: active ? "#ffb703" : "transparent",
      color: active ? "#fff" : "#333",
      fontWeight: 600,
      cursor: "pointer",
      boxShadow: active ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
    }),
    productCard: { border: "none", borderRadius: 12, boxShadow: "0 4px 18px rgba(14,14,14,0.06)", cursor: "pointer", overflow: "hidden" },
    productImg: { height: 140, objectFit: "cover", width: "100%" },
    cartCard: { borderRadius: 10, padding: 12, background: "#fff", marginBottom: 12 },
    cartItem: { background: "#fafafa", padding: 8, borderRadius: 8, marginBottom: 10, border: "1px solid #f0f0f0" },
    smallMuted: { fontSize: 12, color: "#777" },
    primaryBtn: { background: "#28a745", border: "none", flex: 1, padding: "10px 12px", borderRadius: 8, color: "#fff", fontWeight: 700 },
    holdBtn: { background: "#f59e0b", border: "none", flex: 1, padding: "10px 12px", borderRadius: 8, color: "#fff", fontWeight: 700 },
  };


// const handlePrint = () => {
//   const printWindow = window.open('', '_blank');

//   const printContent = 
//     `<!DOCTYPE html>
//     <html>
//     <head>
//       <title>Receipt</title>
//       <meta charset="utf-8" />
//       <style>
//         @page {
//           size: 80mm auto;
//           margin: 0;
//           padding: 0;
//         }

//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         body {
//           width: 80mm;
//           font-family: 'Courier New', monospace;
//           font-size: 10px;
//           padding: 5mm;
//           line-height: 1.3;
//           font-weight: 500; /* 增加整体字体权重 */
//         }

//         /* 标题区域 */
//         .header {
//           text-align: center;
//           margin-bottom: 8px;
//           padding-bottom: 6px;
//           border-bottom: 2px solid #000; /* 加粗边框 */
//         }

//         .store-name {
//           font-size: 16px;
//           font-weight: 900; /* 最大粗细 */
//           margin-bottom: 3px;
//           letter-spacing: 1px;
//         }

//         .invoice-title {
//           font-size: 13px;
//           margin-bottom: 3px;
//           font-weight: 800;
//           color: #333;
//         }

//         .date-time {
//           font-size: 10px;
//           margin-bottom: 5px;
//           font-weight: 700;
//           color: #666;
//         }

//         /* 账单信息区域 */
//         .bill-info {
//           margin: 8px 0;
//           padding: 6px 0;
//           font-weight: 700;
//           background: #f8f8f8;
//           padding: 8px;
//           border-radius: 3px;
//         }

//         .bill-info div {
//           margin-bottom: 4px;
//           display: flex;
//           justify-content: space-between;
//         }

//         .bill-info strong {
//           font-weight: 800;
//           color: #222;
//         }

//         .bill-info .value {
//           font-weight: 600;
//           color: #444;
//         }

//         /* 表格区域 */
//         .items-table {
//           width: 100%;
//           margin: 8px 0;
//         }

//         .table-header {
//           display: flex;
//           width: 100%;
//           margin-bottom: 4px;
//           padding: 4px 0;
//           font-weight: 800;
//           background: #eee;
//           border-bottom: 2px solid #000;
//         }

//         .item-row {
//           display: flex;
//           width: 100%;
//           margin-bottom: 4px;
//           padding: 3px 0;
//           font-weight: 600;
//           border-bottom: 1px dotted #ddd;
//         }

//         .item-name {
//           width: 55%;
//           word-break: break-word;
//           font-weight: 600;
//         }

//         .item-qty {
//           width: 20%;
//           text-align: center;
//           font-weight: 600;
//         }

//         .item-price {
//           width: 25%;
//           text-align: right;
//           font-weight: 700;
//           color: #000;
//         }

//         /* 分隔线 */
//         .divider {
//           border-top: 2px dashed #000;
//           margin: 8px 0;
//         }

//         .line {
//           height: 2px;
//           background: #000;
//           margin: 6px 0;
//         }

//         /* 摘要区域 */
//         .summary-section {
//           margin: 10px 0;
//         }

//         .summary-row {
//           display: flex;
//           justify-content: space-between;
//           margin: 4px 0;
//           padding: 2px 0;
//           font-size: 10px;
//         }

//         .summary-label {
//           font-weight: 700;
//           color: #333;
//         }

//         .summary-value {
//           font-weight: 600;
//           color: #000;
//         }

//         .total-row {
//           display: flex;
//           justify-content: space-between;
//           font-weight: 900;
//           margin: 8px 0;
//           padding: 6px 0;
//           font-size: 12px;
//           border-top: 2px solid #000;
//           border-bottom: 2px solid #000;
//           background: #f0f0f0;
//         }

//         /* 特殊金额样式 */
//         .discount {
//           color: #d32f2f !important;
//           font-weight: 700 !important;
//         }

//         .tax {
//           color: #1976d2 !important;
//           font-weight: 700 !important;
//         }

//         .charge {
//           color: #388e3c !important;
//           font-weight: 700 !important;
//         }

//         /* 页脚 */
//         .footer {
//           text-align: center;
//           margin-top: 12px;
//           padding-top: 8px;
//           border-top: 2px dashed #000;
//           font-size: 10px;
//           font-weight: 700;
//           color: #555;
//         }

//         /* 金额对齐 */
//         .amount-align-right {
//           text-align: right;
//           font-weight: 700;
//         }

//         /* 粗体强调 */
//         .bold {
//           font-weight: 800 !important;
//         }

//         .extra-bold {
//           font-weight: 900 !important;
//         }
//       </style>
//     </head>

//     <body>
//       <div class="header">
//         <div class="store-name">VEEMART STORE</div>
//         <div class="invoice-title">INVOICE RECEIPT</div>
//         <div class="date-time">${new Date().toLocaleString()}</div>
//       </div>

//       <div class="bill-info">
//         <div>
//           <strong>Bill No:</strong>
//           <span class="value">${billData.header.bill_number}</span>
//         </div>
//         <div>
//           <strong>Customer:</strong>
//           <span class="value">${billData.header.customer_name}</span>
//         </div>
//         ${billData.header.customer_mobile ? 
//           `<div>
//             <strong>Mobile:</strong>
//             <span class="value">${billData.header.customer_mobile}</span>
//           </div>` : ''}
//       </div>

//       <div class="line"></div>

//       <div class="items-table">
//         <div class="table-header">
//           <div class="item-name">ITEM</div>
//           <div class="item-qty">QTY</div>
//           <div class="item-price">AMOUNT</div>
//         </div>
        
//         ${billData.details.map(item => 
//           `<div class="item-row">
//             <div class="item-name">${item.product_name}</div>
//             <div class="item-qty">${item.qty}</div>
//             <div class="item-price">₹${parseFloat(item.line_total).toFixed(2)}</div>
//           </div>`
//         ).join('')}
//       </div>

//       <div class="divider"></div>

//       <div class="summary-section">
//         <div class="summary-row">
//           <div class="summary-label">Subtotal:</div>
//           <div class="summary-value">₹${parseFloat(billData.header.sub_total).toFixed(2)}</div>
//         </div>
        
//         ${billData.header.discount_amount > 0 ? 
//           `<div class="summary-row">
//             <div class="summary-label">Discount:</div>
//             <div class="summary-value discount">-₹${parseFloat(billData.header.discount_amount).toFixed(2)}</div>
//           </div>` : ''}
        
//         ${billData.header.tax_amount > 0 ? 
//           `<div class="summary-row">
//             <div class="summary-label">Tax:</div>
//             <div class="summary-value tax">₹${parseFloat(billData.header.tax_amount).toFixed(2)}</div>
//           </div>` : ''}
        
//         ${billData.header.cleaning_charge > 0 ? 
//           `<div class="summary-row">
//             <div class="summary-label">Cleaning Charge:</div>
//             <div class="summary-value charge">₹${parseFloat(billData.header.cleaning_charge).toFixed(2)}</div>
//           </div>` : ''}
//       </div>

//       <div class="total-row">
//         <div class="bold">GRAND TOTAL</div>
//         <div class="extra-bold">₹${parseFloat(billData.header.grand_total).toFixed(2)}</div>
//       </div>

//       <div class="footer">
//         Thank you for your visit! Please come again!
//       </div>

//       <script>
//         window.onload = () => {
//           setTimeout(() => {
//             window.print();
//             window.onafterprint = () => window.close();
//           }, 100);
//         }
//       </script>
//     </body>
//     </html>`;

//   printWindow.document.write(printContent);
//   printWindow.document.close();
// };

const handlePrint = () => {
  const printWindow = window.open('', '_blank');
  
  const printContent = `
  <!DOCTYPE html>
  <html>
  <head>
    <title>Receipt</title>
    <meta charset="utf-8" />
    <style>
      @page {
        size: 80mm auto;
        margin: 0;
        padding: 0;
      }
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      body {
        width: 80mm;
        font-family: Arial, sans-serif;
        font-size: 10px;
        padding: 5mm;
        line-height: 1.4;
        font-weight: normal;
      }
      
      .header {
        text-align: center;
        margin-bottom: 5px;
        padding-bottom: 5px;
      }
      .company-name {
        font-size: 16px;
        font-weight: 900;
        margin-bottom: 3px;
        letter-spacing: 0.5px;
        text-transform: uppercase;
      }
      .company-address {
        font-size: 10px;
        margin-bottom: 2px;
        font-weight: 600;
        line-height: 1.3;
      }
      .contact-info {
        font-size: 9px;
        margin-bottom: 5px;
        font-weight: 600;
        color: #333;
      }
      
      .bill-info {
        margin-bottom: 10px;
        font-size: 11px;
      }
      .bill-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 3px;
      }
      
      .items-table {
        width: 100%;
        border-collapse: collapse;
        margin: 10px 0;
      }
      .items-table th {
        text-align: left;
        padding: 4px 2px;
        font-weight: 800;
        font-size: 11px;
        border-bottom: 2px solid #000;
        border-top: 2px solid #000;
      }
      .items-table td {
        padding: 5px 2px;
        font-size: 11px;
      }
      .item-name {
        width: 50%;
      }
      .item-qty {
        width: 20%;
        text-align: center;
      }
      .item-unit-price {
        width: 20%;
        text-align: center;
      }
      .item-amt {
        width: 30%;
        text-align: right;
        font-weight: 600;
      }
      
      .summary {
        font-size: 11px;
        margin: 10px 0;
        border-top: 2px solid #000;
        padding-top: 8px;
      }
      .summary-row {
        display: flex;
        justify-content: space-between;
        margin: 2px 0;
      }
      .total-row {
        display: flex;
        justify-content: space-between;
        font-weight: 900;
        margin: 8px 0;
        padding: 6px 0;
        font-size: 12px;
        border-top: 2px solid #000;
        border-bottom: 2px solid #000;
      }
      
      .payment {
        font-size: 11px;
        font-weight: 700;
        margin: 8px 0;
      }
      
      .footer {
        text-align: center;
        margin-top: 15px;
        padding-top: 8px;
        border-top: 1px dashed #000;
        font-size: 9px;
        font-weight: 600;
        color: #555;
      }
      
      .text-right {
        text-align: right;
      }
      .text-center {
        text-align: center;
      }
      .bold {
        font-weight: 800;
      }
    </style>
  </head>
  <body>
    <div class="header">
      <div class="company-name">ROYALS FISH PVT LTD</div>
      <div class="company-address">
        S USMAN ROAD, T. NAGAR,<br>
        CHENNAI, TAMIL NADU.
      </div>
      <div class="contact-info">
        PHONE : 044 258636222 
      </div>
    </div>
    
    <div class="bill-info">
      <div class="bill-row">
        <span>Bill: <strong>#${billData.header.bill_number}</strong></span>
       
      </div>
      <div class="bill-row">
        <span>Customer: <strong>${billData.header.customer_name}</strong></span>
        <span>Mobile: ${billData.header.customer_mobile}</span>
      </div>
    </div>
    
    <table class="items-table">
      <thead>
        <tr>
          <th class="item-name">Item</th>
          <th class="item-qty">Qty</th>
          <th class="item-unit-price">U.Price</th>
          <th class="item-amt">Amt</th>
        </tr>
      </thead>
      <tbody>
        ${billData.details.map(item => `
          <tr>
            <td class="item-name">${item.product_name}</td>
            <td class="item-qty">${item.qty}</td>
            <td class="item-unit-price">${item.unit_price}</td>
            <td class="item-amt">${parseFloat(item.line_total).toFixed(2)}</td>
          </tr>
        `).join('')}
      </tbody>
    </table>
    
    <div class="summary">
      <div class="summary-row">
        <span>Sub Total</span>
        <span>${billData.details.length}</span>
        <span class="bold">${parseFloat(billData.header.sub_total).toFixed(2)}</span>
      </div>
      
      ${billData.header.cleaning_charge > 0 ? `
      <div class="summary-row">
        <span>Cleaning Charge</span>
        <span></span>
        <span class="bold">${parseFloat(billData.header.cleaning_charge).toFixed(2)}</span>
      </div>
      ` : ''}

      ${billData.header.delivery_charge > 0 ? `
      <div class="summary-row">
        <span>Delivery Charge</span>
        <span></span>
        <span class="bold">${parseFloat(billData.header.delivery_charge).toFixed(2)}</span>
      </div>
      ` : ''}
      
      ${billData.header.discount_amount > 0 ? `
      <div class="summary-row">
        <span>(-) Discount</span>
        <span></span>
        <span class="bold">${parseFloat(billData.header.discount_amount).toFixed(2)}</span>
      </div>
      ` : ''}
      
      <div class="total-row">
        <span>TOTAL</span>
        <span></span>
        <span>₹${parseFloat(billData.header.grand_total).toFixed(2)}</span>
      </div>
    </div>
    
    <div class="payment">
      <div class="summary-row">
        <span>${billData.header.payment_mode || 'Not Paid'} :</span>
        <span></span>
        <span>₹${parseFloat(billData.header.grand_total).toFixed(2)}</span>
      </div>
    </div>
    
    <div class="footer">
      Thank you for your visit! Please come again!
    </div>
    
    <script>
      window.onload = () => {
        setTimeout(() => {
          window.print();
          window.onafterprint = () => window.close();
        }, 100);
      }
    </script>
  </body>
  </html>`;
  
  printWindow.document.write(printContent);
  printWindow.document.close();
};



const removeCutting = (id) => {
  setCart(prev =>
    prev.map(item =>
      item.id === id
        ? { ...item, cutting_name: null, cutting_code: null }
        : item
    )
  );
};




  //  const handlePrint = async (billId) => {
  //   // setLoading(true);
  //   try {
  //     const res = await axios.post(
  //       `${var_api}veemart_instore_pos_billing/print-billing-detail/${billId}`,
  //     );

  //     console.log("Printed Successfully!");
  //   } catch (err) {
  //     console.log("Print Failed: " + (err.response?.data?.details || err.message));
  //   }

  //   // setLoading(false);
  // };
    const warehouse_id = parseInt(localStorage.getItem('warehouse_id'));

  const checkSubscriptionStatus = async () => {

    if (!warehouse_id) return;
  
    try {
      const res = await axios.get(
        `${var_api}subscription/check-current-month/${warehouse_id}`
      );
  
      // ❌ Case 1: No subscription created for this month
      if (res.data?.success === false && res.data?.exists === false) {
        setSubMessageOnly(true);
        setShowSubModal(true);
        setSubscriptionData(res.data)
        return;
      }
  
      // ❌ Case 2: Subscription exists but not paid
      if (res.data?.success === false && res.data?.is_paid === false) {
        setSubMessageOnly(false);
        setShowSubModal(true);
        setSubscriptionData(res.data);
        return;
      }
  
    } catch (err) {
      console.error("Subscription check failed", err);
    }
  };


    const handlePayNow = async () => {
  try {
    setPaying(true);

    // 1️⃣ Create Razorpay order (backend API)
    const orderRes = await axios.post(
      `${var_api}subscription/create-razorpay-order`,
      {
        warehouse_id: warehouse_id,
        amount: parseFloat(subscriptionData?.total_unpaid_amount || 0) // example subscription amount
      }
    );

    const { order_id, amount, key } = orderRes.data;

    // 2️⃣ Open Razorpay
    const options = {
      key,
      amount,
      currency: "INR",
      name: "Veemart Subscription",
      description: "Monthly Subscription",
      order_id,
      handler: async function (response) {
        // 3️⃣ Verify payment
        await axios.post(`${var_api}subscription/verify-payment`, {
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
          warehouse_id: warehouse_id,
        });

        toast.success("Subscription paid successfully 🎉");
        setShowSubModal(false);
      },
      prefill: {
        name: "Warehouse Admin",
      },
      theme: {
        color: "#0d6efd",
      },
    };

    const razorpay = new window.Razorpay(options);
    razorpay.open();

  } catch (err) {
    console.error("Payment failed", err);
    toast.error("Payment failed");
  } finally {
    setPaying(false);
  }
};

const filteredProducts = productData.filter((p) => {
  const name =
    (p.product_name || p.variant_name || "").toLowerCase();

  return name.includes(searchText.toLowerCase());
});

const getTotalCuttingQty = () => {
  const baseId =
    cuttingForProduct?.product_id ||
    cuttingForProduct?.id ||
    cuttingForProduct?.veemart_product_id;

  return cart
    .filter(
      item =>
        String(item.product_id) === String(baseId) &&
        item.cutting_id
    )
    .reduce((sum, item) => sum + Number(item.qty || 0), 0);
};






  return (
    <div style={styles.app}>
      {/* SIDEBAR */}
      {/* <div style={styles.sidebar}>
        <div style={styles.sideTop}>
          <div style={{ display: "flex", justifyContent: sidebarCollapsed ? "center" : "space-between", alignItems: "center" }}>
            <div style={styles.logoBox}>
              <div style={styles.logoSquare}>{!sidebarCollapsed ? "WP" : "W"}</div>
              {!sidebarCollapsed && <div style={{ fontWeight: 700 }}>Warehouse POS</div>}
            </div>
            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
              <button
                onClick={toggleSidebar}
                aria-label="toggle"
                style={{ border: "none", background: "transparent", padding: 6, cursor: "pointer" }}
                title={sidebarCollapsed ? "Expand" : "Collapse"}
              >
                <Icon name="menu" size={20} />
              </button>
            </div>
          </div>

          <div style={styles.iconRow}>
            <div style={styles.smallIconWrap}><div style={{width:28,height:28,display:"flex",alignItems:"center",justifyContent:"center"}}><Icon name="home" size={18} /></div>{!sidebarCollapsed && <span style={{fontWeight:600}}>Home</span>}</div>
            <div style={styles.smallIconWrap}><div style={{width:28,height:28,display:"flex",alignItems:"center",justifyContent:"center"}}><Icon name="customers" size={18} /></div>{!sidebarCollapsed && <span style={{fontWeight:600}}>Customers</span>}</div>
            <div style={styles.smallIconWrap}><div style={{width:28,height:28,display:"flex",alignItems:"center",justifyContent:"center"}}><Icon name="tables" size={18} /></div>{!sidebarCollapsed && <span style={{fontWeight:600}}>Tables</span>}</div>
            <div style={styles.smallIconWrap}><div style={{width:28,height:28,display:"flex",alignItems:"center",justifyContent:"center"}}><Icon name="bills" size={18} /></div>{!sidebarCollapsed && <span style={{fontWeight:600}}>Bills</span>}</div>
            <div style={styles.smallIconWrap}><div style={{width:28,height:28,display:"flex",alignItems:"center",justifyContent:"center"}}><Icon name="reports" size={18} /></div>{!sidebarCollapsed && <span style={{fontWeight:600}}>Reports</span>}</div>
            <div style={styles.smallIconWrap}><div style={{width:28,height:28,display:"flex",alignItems:"center",justifyContent:"center"}}><Icon name="settings" size={18} /></div>{!sidebarCollapsed && <span style={{fontWeight:600}}>Settings</span>}</div>
          </div>
        </div>

        <div style={{ padding: 14 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
            <div style={{ width: 36, height: 36, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", background: "#ff6b6b" }}><Icon name="logout" size={16} /></div>
            {!sidebarCollapsed && <div style={{ fontWeight: 700 }}>Logout</div>}
          </div>
        </div>
      </div> */}

      {/* MAIN */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {/* TOPBAR */}
        <div style={styles.topbar}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>

               {/* Home Icon */}
      <button 
        onClick={() => window.location.href = '/warehouse-dashboard'}
        style={{
          background: 'linear-gradient(90deg, #ffb703, #fb8500)',
          border: 'none',
          cursor: 'pointer',
          padding: '6px',
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: '0.2s'
        }}
        onMouseOver={(e) => e.currentTarget.style.background = '#f0f0f0'}
        onMouseOut={(e) => e.currentTarget.style.background = 'none'}
        title="Dashboard"
      >
        <svg 
          width="22" 
          height="22" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="white"
        >
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" strokeWidth="2"/>
          <polyline points="9 22 9 12 15 12 15 22" strokeWidth="2"/>
        </svg>
      </button>
      
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ fontWeight: 700, fontSize: 18 }}>Warehouse POS</div>
                <div style={{ fontSize: 12, color: "#888" }}></div>

                 <div style={{ display: "flex", alignItems: "center", background: "#f1f3f5", padding: "6px 10px", borderRadius: 20 }}>
              <Icon name="search" size={16} />
              <input placeholder="Search product..." value={searchText}
                onChange={(e) => setSearchText(e.target.value)} style={{ border: "none", background: "transparent", outline: "none", marginLeft: 8, fontSize: 14 }} />
            </div>
              </div>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ display: "flex", alignItems: "center",  padding: "6px 10px", borderRadius: 20 }}>
               <Button
                                          size="sm"
                                          variant="primary"
                                          onClick={() => window.location.href = '/order-list'}
                                        >Go to Orders List
                                        </Button>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: 13, fontWeight: 700 }}>{localStorage.getItem("warehouse_name")}</div>
                <div style={{ fontSize: 11, color: "#888" }}>Warehouse</div>
              </div>
              <div style={{ width: 36, height: 36, borderRadius: 8, background: "#e9ecef", display: "flex", alignItems: "center", justifyContent: "center" }}>  {localStorage.getItem("warehouse_name")?.charAt(0) || "?"}</div>
            </div>
          </div>
        </div>

        {/* CONTENT */}
        <div style={styles.contentWrap}>
          {/* LEFT: PRODUCTS */}
          <div style={styles.leftPane}>
            {/* Category tabs - removed business selection */}
            
            {/* Grid */}
            <Row style={{ marginTop: 10 }}>
           {/* Category Tabs */}
{categoryData ? (
  categoryData.length > 0 ? (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        gap: "8px",
        flexWrap: "wrap",
        marginBottom: "12px",
      }}
    >
      {categoryData.map((cat) => (
        <div
          key={cat.id}
          onClick={() => handleCategoryClick(cat)}
          style={{
            padding: "6px 14px",
            borderRadius: "25px",
            background:
              selectedCategory?.id === cat.id ||
              selectedCategory?.veemart_category_name?.toLowerCase() === "cold cut" &&
              cat.veemart_category_name?.toLowerCase() === "cold cut"
                ? "linear-gradient(90deg, #ffb703, #fb8500)"
                : "#f5f5f5",
            color:
              selectedCategory?.id === cat.id ||
              selectedCategory?.veemart_category_name?.toLowerCase() === "cold cut" &&
              cat.veemart_category_name?.toLowerCase() === "cold cut"
                ? "#fff"
                : "#333",
            fontWeight: 600,
            fontSize: "13px",
            cursor: "pointer",
            border:
              selectedCategory?.id === cat.id ||
              selectedCategory?.veemart_category_name?.toLowerCase() === "cold cut" &&
              cat.veemart_category_name?.toLowerCase() === "cold cut"
                ? "none"
                : "1px solid #e0e0e0",
            transition: "all 0.2s ease-in-out",
          }}
        >
          {cat.veemart_category_name}
        </div>
      ))}
    </div>
  ) : (
    <div style={{ textAlign: "center", color: "#777", marginTop: "20px" }}>
      No categories found.
    </div>
  )
) : (
  <div style={{ textAlign: "center", color: "#777", marginTop: "20px" }}>
    Loading categories...
  </div>
)}





              {/* Product Cards */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
                  gap: 16,
                  alignItems: "start",
                  padding: "4px 2px 30px",
                }}
              >
           
{selectedCategory && filteredProducts.length > 0 ? (
  filteredProducts.map((p) => {
    // ✅ Handle both regular products and Cold Cut variants
    const baseId = p.product_id || p.id || p.veemart_product_id;
    const isInCart = cart.some(c => String(c.product_id) === String(baseId));
    
    // ✅ Detect if this is a Cold Cut variant
    const isColdCutVariant = p.variant_name && p.variant_image !== undefined;
    const displayName = isColdCutVariant ? p.variant_name : p.product_name;
    const displayImage = isColdCutVariant 
      ? (p.variant_image ? `${image_api}${p.variant_image.replace(/^test\//, "")}` : defaultImg)
      : (p.product_image ? `${image_api}${p.product_image.replace(/^test\//, "")}` : defaultImg);
      const isOutOfStock = Number(p.total_qty) <= 0 || p.is_sold == 0;

    
    return (
      <div
        key={isColdCutVariant ? `variant-${p.id}` : `product-${baseId}`}
        onClick={() => {
  if (!isOutOfStock) handleProductClick(p);
}}
        style={{
          background: isInCart ? "#fffdea" : "#fff",
          borderRadius: "14px",
          border: isInCart ? "2px solid #ffb703" : "1px solid #f0f0f0",
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          cursor: "pointer",
          overflow: "hidden",
          transition: "transform 0.15s ease",
          display: "flex",
          flexDirection: "column",
          opacity: isOutOfStock ? 0.6 : 1,
        }}
      onMouseEnter={(e) => {
  if (!isOutOfStock) e.currentTarget.style.transform = "translateY(-4px)";
}}
onMouseLeave={(e) => {
  if (!isOutOfStock) e.currentTarget.style.transform = "translateY(0)";
}}

      >
        {/* Image */}
        <div style={{ width: "100%", height: "120px", overflow: "hidden", position: "relative" }}>
          <img
            src={displayImage}
            alt="product"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              filter: isOutOfStock ? "grayscale(100%)" : "none",
            }}
          />

           {isOutOfStock && (
    <div
      style={{
        position: "absolute",
        top: 8,
        right: 8,
        background: "#dc2626",
        color: "#fff",
        fontSize: "10px",
        fontWeight: 700,
        padding: "4px 8px",
        borderRadius: "6px",
        zIndex: 2,
      }}
    >
      SOLD OUT
    </div>
  )}
        </div>

        {/* Body */}
        <div style={{ padding: "10px", textAlign: "center" }}>
          <div
            style={{
              fontSize: "13px",
              fontWeight: 700,
              color: "#111827",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {displayName}
          </div>

          <div
            style={{
              fontSize: "11px",
              color: "#6b7280",
              margin: "4px 0",
            }}
          >
            {/* {p.gross_weight ? `${p.gross_weight}` : ""}
            {p.uom && ` ${p.uom}`}  */}
            {p.qty_count ? ` | Avl: ${p.qty_count}` : p.qty_available ? ` | Avl: ${p.qty_available}` : ''}
          </div>

          <div>
            <span
              style={{
                display: "block",
                fontWeight: "bold",
                fontSize: "13px",
                color: "#111827",
              }}
            >
              ₹{Number(p?.final_selling_price || p?.unit_price || 0).toFixed(2)}
            </span>
            {
              isInCart && !isOutOfStock &&(
                  <div style={{ display: 'flex', justifyContent: 'center', gap: 8, alignItems: 'center' }}>
              {/* <span style={{ fontSize: 11, color: '#6b7280' }}>Tap to add</span> */}
              <button title="Choose Cutting" onClick={(e) => { e.stopPropagation(); handleOpenCuttingModal(p); }} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 12l20-10-6 22-4-6-4 6-6-12z" stroke="#444" strokeWidth="1.2"/></svg>
              </button>
            </div>
              )
            }
          
          </div>
        </div>
      </div>
    );
  })
) :  selectedCategory ? (
                  <div
                    style={{
                      gridColumn: "1 / -1",
                      textAlign: "center",
                      color: "#777",
                      padding: 20,
                    }}
                  >
                    No products available in this category.
                  </div>
                ) : (
                  <div
                    style={{
                      gridColumn: "1 / -1",
                      textAlign: "center",
                      color: "#777",
                      padding: 20,
                    }}
                  >
                    Select a category to view products.
                  </div>
                )}
              </div>
            </Row>
          </div>

          {/* RIGHT: CART / BILL */}
          <div style={styles.rightPane}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <div style={{ fontWeight: 800, fontSize: 16 }}>Bill</div>
              <div style={{ display: "flex", gap: 8 }}>
<Button
  variant="primary"
  size="sm"
  onClick={openAddCustomerModal}
  style={{
    borderRadius: 8,
    color: "#fff",
    backgroundColor: "#0d6efd",   // Bootstrap primary blue
    borderColor: "#0d6efd"
  }}
>
  + Add Customer
</Button>
                <Button variant="danger" size="sm" onClick={() => { setCart([]); setExtraDiscount(0); }} style={{ borderRadius: 8 }}>Clear</Button>
              </div>
            </div>

            {/* <div style={{ marginBottom: 10, color: "#666", fontSize: 13 }}>Warehouse: WH001</div> */}
            {/* <div style={{ marginBottom: 10, color: "#666", fontSize: 13 }}>
            Warehouse: {localStorage.getItem("warehouse_no") || "N/A"}
          </div>
          <div style={{ marginBottom: 10, color: "#666", fontSize: 13 }}>
  {localStorage.getItem("warehouse_name") || localStorage.getItem("warehouse_no") || "N/A"}
</div> */}

            {/* Customer Phone */}
            <div style={{ marginBottom: 14, position: "relative" }}>
  <label
    style={{
      fontSize: 13,
      fontWeight: 600,
      marginBottom: 6,
      display: "block",
    }}
  >
    Customer Phone
  </label>

  <div style={{ display: "flex", gap: 8 }}>
    <input
      value={customerPhoneSearch}
      onChange={(e) => setCustomerPhoneSearch(e.target.value)}
      placeholder="Enter phone number"
      style={{
        flex: 1,
        padding: "8px",
        borderRadius: 6,
        border: "1px solid #d9d9d9",
        fontSize: 13,
      }}
    />

    {/* <button
      onClick={handleCustomerPhoneSearch}
      style={{
        padding: "8px 16px",
        borderRadius: 6,
        background: "#007bff",
        color: "#fff",
        border: "none",
        cursor: "pointer",
        fontWeight: 600,
        fontSize: 13,
        whiteSpace: "nowrap",
      }}
    >
      Search / Create
    </button> */}
  </div>

  {/* Loading */}
  {searchLoading && (
    <div style={{ marginTop: 6, fontSize: 12, color: "#666" }}>
      Searching...
    </div>
  )}

  {/* Search Results Dropdown */}
  {searchResults?.length > 0 && !selectedCustomer && (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: 6,
        marginTop: 6,
        zIndex: 9999,
        maxHeight: 200,
        overflowY: "auto",
      }}
    >
      {searchResults.map((cust) => (
        <div
          key={cust.id}
          onClick={() => selectCustomerFromSearch({
            value: cust.id,
            raw: cust
          })}
          style={{
            padding: "8px 10px",
            fontSize: 13,
            cursor: "pointer",
            borderBottom: "1px solid #f0f0f0",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = "#f5faff")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = "#fff")
          }
        >
          <strong>{cust.customer_name}</strong>
          <div style={{ fontSize: 12, color: "#666" }}>
            {cust.customer_mobile_whatsapp || cust.customer_mobile}
          </div>
        </div>
      ))}
    </div>
  )}

  {/* Selected Customer */}
  {selectedCustomer && (
    <div style={{ marginTop: 8, fontSize: 12, color: "#333" }}>
      Selected: <strong>{selectedCustomer.name}</strong>{" "}
      <span style={{ color: "#666" }}>
        ({selectedCustomer.mobile || ""})
      </span>
    </div>
  )}
</div>


            {/* Payment Mode */}
            {/* <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 13, fontWeight: 600, marginBottom: 6, display: 'block' }}>
                Payment Mode
              </label>
              <select value={paymentMode} onChange={(e) => setPaymentMode(e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: 6, border: '1px solid #d9d9d9', fontSize: 13 }}>
                {paymodeOptions.length > 0 ? (
                  paymodeOptions.map((pm) => <option key={pm.value} value={pm.value}>{pm.label}</option>)
                ) : (
                  <>
                    <option value="Cash">Cash</option>
                    <option value="Card">Card</option>
                  </>
                )}
              </select>
            </div> */}

            {/* Remarks */}
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 13, fontWeight: 600, marginBottom: 6, display: 'block' }}>
                Remarks
              </label>
              <input 
                type="text"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                placeholder="Any remarks..."
                style={{ 
                  width: '100%', 
                  padding: '8px', 
                  borderRadius: 6, 
                  border: '1px solid #d9d9d9',
                  fontSize: 13
                }}
              />
            </div>

{/* Items list */}
{/* Items list */}
<div style={{ marginBottom: 16 }}>
  {cart.length === 0 && <div style={{ textAlign: "center", color: "#9aa0a6", padding: 20, fontSize: 13 }}>No items in cart. Tap products to add.</div>}
  
  {/* Group cart items by product_id */}
  {Object.entries(
    cart.reduce((acc, item) => {
      const key = item.product_id;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {})
  ).map(([productId, items], idx) => {
    const firstItem = items[0];
    const baseItem = items.find(i => !i.cutting_id) || items[0];
    const totalQty = items.reduce((sum, it) => sum + Number(it.qty || 0), 0);

    // base product price
    const basePrice = Number(baseItem.final_selling_price || 0);
    const totalPrice = baseItem.qty * basePrice;


    // const totalPrice = items.reduce((sum, it) => sum + (Number(it.final_selling_price || 0) * Number(it.qty || 0)), 0);

        // ✅ UPDATE ONLY BASE PRODUCT QTY
  // const updateBaseQty = (newQty) => {
  //   if (newQty <= 0) {
  //     setCart(cur =>
  //       cur.filter(c => String(c.product_id) !== String(productId))
  //     );
  //     return;
  //   }

  //   setCart(cur =>
  //     cur.map(c => {
  //       if (
  //         String(c.product_id) === String(productId) &&
  //         !c.cutting_id
  //       ) {
  //         return { ...c, qty: newQty };
  //       }
  //       return c;
  //     })
  //   );
  // };

  const updateBaseQty = (newQty) => {
  setCart((cur) => {
    // ❌ If qty <= 0 → remove entire product (base + cuttings)
    if (newQty <= 0) {
      return cur.filter(
        (c) => String(c.product_id) !== String(productId)
      );
    }

    return cur
      // ✅ Remove all cutting items for this product
      .filter(
        (c) =>
          !(
            String(c.product_id) === String(productId) &&
            c.cutting_id
          )
      )
      // ✅ Update base item qty
      .map((c) => {
        if (
          String(c.product_id) === String(productId) &&
          !c.cutting_id
        ) {
          return { ...c, qty: newQty };
        }
        return c;
      });
  });
};

    
    return (
    <div
  key={productId}
  style={{
    background: "#fff",
    padding: "6px 8px",
    borderRadius: 6,
    marginBottom: 6,
    border: "1px solid #eee",
  }}
>
  {/* HEADER */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 6,
    }}
  >
    <div style={{ flex: 1, minWidth: 0 }}>
      <div
        style={{
          fontSize: 12,
          fontWeight: 700,
          color: "#111",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {idx + 1}. {firstItem.product_name}
      </div>
    </div>

    <div
      style={{
        fontSize: 13,
        fontWeight: 800,
        color: "#16a34a",
        whiteSpace: "nowrap",
      }}
    >
      ₹{totalPrice.toFixed(2)}
    </div>
  </div>

  {/* QTY CONTROL */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 4,
      marginTop: 6,
    }}
  >
     <span style={{ fontSize: 10, color: "#777", marginLeft: 4 }}>
      Qty
    </span>
    {/* <button
      onClick={() => updateBaseQty(Number((totalQty - 0.25).toFixed(2)))}
      style={qtyBtnCompact("#dc3545")}
    >
      −
    </button> */}

    <input
      type="number"
      step="0.25"
      min="0.25"
      value={baseItem.qty}
      onChange={(e) =>
        updateBaseQty(Number(parseFloat(e.target.value || 0).toFixed(2)))
      }
      style={{
        width: 80,
        height: 26,
        textAlign: "center",
        fontSize: 11,
        fontWeight: 700,
        border: "1px solid #ddd",
        borderRadius: 4,
        marginLeft: 4
      }}
    />

    {/* <button
      onClick={() => updateBaseQty(Number((totalQty + 0.25).toFixed(2)))}
      style={qtyBtnCompact("#16a34a")}
    >
      +
    </button> */}
  </div>

  {/* CUTTING CHIPS */}
  {items.some(it => it.cutting_name) && (
    <div style={{ marginTop: 6 }}>
      <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
        {items.map(
          it =>
            it.cutting_name && (
              <div
                key={it.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  padding: "2px 6px",
                  borderRadius: 12,
                  background: "#fff7e6",
                  border: "1px solid #ffd591",
                  fontSize: 10,
                  fontWeight: 600,
                  color: "#8c6d1f",
                }}
              >
                ✂️ {it.cutting_name}
              </div>
            )
        )}
      </div>
    </div>
  )}

  {/* ACTIONS */}
  <div
    style={{
      display: "flex",
      justifyContent: "flex-end",
      gap: 6,
      marginTop: 6,
    }}
  >
    <button
      onClick={() => {
        fetchCuttingStyles(productId)
        setCuttingForProduct(firstItem);
        setShowCuttingModal(true);
      }}
      title="Edit Cutting"
      style={actionBtn("#555")}
    >
      ✂️
    </button>

    <button
      onClick={() =>
        setCart(cur =>
          cur.filter(c => String(c.product_id) !== String(productId))
        )
      }
      title="Remove"
      style={actionBtn("#e03131")}
    >
     <i className="fa fa-trash"></i>
    </button>
  </div>
</div>


    );
  })}
</div>

            {/* SUMMARY */}
            <div style={{ marginTop: 16, paddingTop: 12, borderTop: '1px solid #f0f0f0' }}>
              <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: 8 }}>
                <div style={styles.smallMuted}>Subtotal</div>
                <div style={{ fontWeight: 600, fontSize: 13 }}>₹{subtotal?.toFixed(2)}</div>
              </div>
              {/* <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: 8 }}>
                <div style={styles.smallMuted}>Tax (12%)</div>
                <div style={{ fontWeight: 600, fontSize: 13 }}>₹{tax.toFixed(2)}</div>
              </div> */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: 8 }}>
              <div style={styles.smallMuted}>Cleaning Charge</div>
              <input 
                type="number" 
                min="0"
                value={cleaningCharge} 
                onChange={(e) => setCleaningCharge(Number(e.target.value) || 0)} 
                style={{ 
                  width: 80, 
                  padding: "6px 8px", 
                  borderRadius: 6, 
                  border: "1px solid #ddd", 
                  fontSize: 13, 
                  textAlign: 'right' 
                }} 
              />
            </div>


             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: 8 }}>
              <div style={styles.smallMuted}>Delivery Charge</div>
              <input 
                type="number" 
                min="0"
                value={deliveryCharge} 
                onChange={(e) => setDeliveryCharge(Number(e.target.value) || 0)} 
                style={{ 
                  width: 80, 
                  padding: "6px 8px", 
                  borderRadius: 6, 
                  border: "1px solid #ddd", 
                  fontSize: 13, 
                  textAlign: 'right' 
                }} 
              />
            </div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: 12 }}>
                <div style={styles.smallMuted}>Extra Discount</div>
                <input type="number"                 min="0"
 value={extraDiscount} onChange={(e) => setExtraDiscount(Number(e.target.value) || 0)} style={{ width: 80, padding: "6px 8px", borderRadius: 6, border: "1px solid #ddd", fontSize: 13, textAlign: 'right' }} />
              </div>

              <hr style={{ border: "none", height: 1, background: "#f0f0f0", margin: "12px 0" }} />

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: 14 }}>
                <div style={{ fontSize: 15, fontWeight: 700 }}>Payable</div>
                <div style={{ color: "#16a34a", fontSize: 18, fontWeight: 800 }}>₹{payable.toFixed(2)}</div>
              </div>

              <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
               <button style={styles.holdBtn} onClick={handleHoldOrder}>Hold Order</button>
                <button style={styles.primaryBtn} onClick={handleCheckout}>Proceed</button>
              </div>
            </div>

            <div style={{ marginTop: 12, fontSize: 12, color: "#888" }}>
              <div>Payment: Not Paid</div>
              <div style={{ marginTop: 6 }}>Created By: AdminUser</div>
            </div>
          </div>
        </div>
      </div>

      {/* Bill Modal */}
      {/* <Modal
        show={showBillModal}
        onHide={() => setShowBillModal(false)}
        size="sm"
        centered
        className="receipt-modal"
      >
        <Modal.Body className="p-0">
          {billData ? (
            <div id="bill-print-section" className="p-3 receipt">
           
              <div className="text-center mb-2">
                <h6 className="fw-bold mb-1" style={{fontSize: '16px'}}>VEEMART STORE</h6>
                <small className="text-muted d-block">INVOICE RECEIPT</small>
                <small className="text-muted">{new Date(billData.header.bill_date_time).toLocaleString()}</small>
              </div>

           
              <div className="small mb-2">
                <div className="d-flex justify-content-between">
                  <span>Bill #: <strong>#{billData.header.bill_number}</strong></span>
                  <span>Pay: {billData.header.payment_mode}</span>
                </div>
                <div>Customer: {billData.header.customer_name || 'Walk-in Customer'}</div>
                <div>Mobile: {billData.header.customer_mobile || 'N/A'}</div>
              </div>

              <hr style={{margin: '8px 0', borderColor: '#000'}} />

            
              <div className="mb-2">
                <div className="row small fw-bold mb-1">
                  <div className="col-6">ITEM</div>
                  <div className="col-2 text-center">QTY</div>
                  <div className="col-4 text-end">AMOUNT</div>
                </div>
                
                {billData.details.map((item, idx) => (
                  <div key={idx} className="row small py-1" style={{borderBottom: '1px dotted #ccc'}}>
                    <div className="col-6">
                      <div className="fw-semibold" style={{fontSize: '11px'}}>
                        {item.product_name}
                      </div>
                      <div style={{fontSize: '10px'}} className="text-muted">
                        {item.discount_percent > 0 && `Disc: ${item.discount_percent}% `}
                        {item.tax_percent > 0 && `Tax: ${item.tax_percent}%`}
                      </div>
                    </div>
                    <div className="col-2 text-center">
                      {item.qty}
                    </div>
                    <div className="col-4 text-end">
                      ₹{parseFloat(item.line_total).toFixed(2)}
                    </div>
                  </div>
                ))}
              </div>

              <hr style={{margin: '8px 0', borderColor: '#000'}} />

          
              <div className="mt-2">
                <div className="d-flex justify-content-between small">
                  <span>Subtotal:</span>
                  <span>₹{parseFloat(billData.header.sub_total).toFixed(2)}</span>
                </div>
                {billData.header.discount_amount > 0 && (
                  <div className="d-flex justify-content-between small">
                    <span>Discount:</span>
                    <span className="text-danger">-₹{parseFloat(billData.header.discount_amount).toFixed(2)}</span>
                  </div>
                )}
                {billData.header.tax_amount > 0 && (
                  <div className="d-flex justify-content-between small">
                    <span>Tax:</span>
                    <span className="text-info">₹{parseFloat(billData.header.tax_amount).toFixed(2)}</span>
                  </div>
                )}
                {billData.header.cleaning_charge > 0 && (
                  <div className="d-flex justify-content-between small">
                    <span>Cleaning Charge:</span>
                    <span className="text-success">₹{parseFloat(billData.header.cleaning_charge).toFixed(2)}</span>
                  </div>
                )}
                <div className="d-flex justify-content-between fw-bold border-top pt-1 mt-1">
                  <span>TOTAL:</span>
                  <span>₹{parseFloat(billData.header.grand_total).toFixed(2)}</span>
                </div>
              </div>

              <div className="text-center mt-3 pt-2 border-top">
                <small className="text-muted d-block">
                  Thank you for your purchase!
                </small>
                <small className="text-muted">
                  Visit again 👍
                </small>
                <small className="text-muted d-block mt-1">
                  Printed: {new Date().toLocaleString()}
                </small>
              </div>
            </div>
          ) : (
            <div className="text-center py-4">
              <p>Loading...</p>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer className="border-0">
          <Button variant="outline-secondary" size="sm" onClick={() => setShowBillModal(false)}>
            Close
          </Button>
          <Button variant="primary" size="sm" onClick={handlePrint}>
            Print Receipt
          </Button>
        </Modal.Footer>
</Modal> */}


<Modal
  show={showBillModal}
  onHide={() => setShowBillModal(false)}
  size="sm"
  centered
  className="receipt-modal"
>
  <Modal.Body className="p-0">
    {billData ? (
      <div id="bill-print-section" style={{ padding: '15px', background: '#fff' }}>
        {/* Header matching image */}
        <div style={{ textAlign: 'center', marginBottom: '10px' }}>
          <div style={{ 
            fontSize: '16px', 
            fontWeight: '900', 
            marginBottom: '3px',
            textTransform: 'uppercase'
          }}>
            ROYALS FISH PVT LTD
          </div>
          <div style={{ 
            fontSize: '10px', 
            fontWeight: '600',
            lineHeight: '1.3',
            marginBottom: '2px'
          }}>
            S USMAN ROAD, T. NAGAR,<br />
            CHENNAI, TAMIL NADU.
          </div>
          <div style={{ 
            fontSize: '9px', 
            fontWeight: '600',
            marginBottom: '5px',
            color: '#333'
          }}>
            PHONE : 044 258636222 
          </div>
          {/* <div style={{ 
            fontSize: '14px', 
            fontWeight: '900',
            margin: '6px 0',
            textTransform: 'uppercase',
            borderTop: '2px solid #000',
            borderBottom: '2px solid #000',
            padding: '4px 0'
          }}>
            Retail Invoice
          </div> */}
        </div>
        
      <div className="small mb-2">
                <div className="d-flex justify-content-between">
                  <span>Bill: <strong>#{billData.header.bill_number}</strong></span>
                  {/* <span>Pay: {billData.header.payment_mode}</span> */}
                </div>
                <div className="d-flex justify-content-between">
                  <span>Customer: {billData.header.customer_name || 'Walk-in Customer'}</span>
                  <span>Mobile: {billData.header.customer_mobile || 'N/A'}</span>
                  </div>
                
              </div>
        
        {/* Divider */}
        {/* <hr style={{ border: 'none', height: '2px', background: '#000', margin: '8px 0' }} /> */}
        
        {/* Items table */}
        <table style={{ width: '100%', borderCollapse: 'collapse', margin: '10px 0' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #000', borderTop: '2px solid #000' }}>
              <th style={{ 
                textAlign: 'left', 
                padding: '4px 2px',
                fontWeight: '800',
                fontSize: '11px',
                width: '50%'
              }}>Item</th>
              <th style={{ 
                textAlign: 'center', 
                padding: '4px 2px',
                fontWeight: '800',
                fontSize: '11px',
                width: '20%'
              }}>Qty</th>
               <th style={{ 
                textAlign: 'center', 
                padding: '4px 2px',
                fontWeight: '800',
                fontSize: '11px',
                width: '20%'
              }}>U.Price</th>
              <th style={{ 
                textAlign: 'right', 
                padding: '4px 2px',
                fontWeight: '800',
                fontSize: '11px',
                width: '30%'
              }}>Amt</th>
            </tr>
          </thead>
          <tbody>
            {billData.details.map((item, idx) => (
              <tr key={idx} 
              // style={{ borderBottom: '1px solid #eee' }}
              >
                <td style={{ 
                  padding: '5px 2px',
                  fontSize: '11px'
                }}>{item.product_name}</td>
                <td style={{ 
                  padding: '5px 2px',
                  textAlign: 'center',
                  fontSize: '11px'
                }}>{item.qty}</td>
                <td style={{ 
                  padding: '5px 2px',
                  textAlign: 'center',
                  fontSize: '11px'
                }}>{item.unit_price}</td>
                <td style={{ 
                  padding: '5px 2px',
                  textAlign: 'right',
                  fontSize: '11px',
                  fontWeight: '600'
                }}>{parseFloat(item.line_total).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {/* Divider */}
        {/* <hr style={{ border: 'none', height: '2px', background: '#000', margin: '8px 0' }} /> */}
        
        {/* Summary section */}
        <div style={{ fontSize: '11px', margin: '10px 0', borderTop: '2px solid #000', paddingTop: '8px' }}>
          {/* Subtotal */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            margin: '2px 0'
          }}>
            <span>Sub Total</span>
            <span>{billData.details.length}</span>
            <span style={{ fontWeight: '800' }}>{parseFloat(billData.header.sub_total).toFixed(2)}</span>
          </div>

           {billData.header.cleaning_charge > 0 && (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between',
              margin: '2px 0'
            }}>
              <span>Cleaning Charge</span>
              <span></span>
              <span style={{ fontWeight: '800' }}>{parseFloat(billData.header.cleaning_charge).toFixed(2)}</span>
            </div>
          )}


           {billData.header.delivery_charge > 0 && (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between',
              margin: '2px 0'
            }}>
              <span>Delivery Charge</span>
              <span></span>
              <span style={{ fontWeight: '800' }}>{parseFloat(billData.header.delivery_charge).toFixed(2)}</span>
            </div>
          )}
          
          {/* Discount */}
          {billData.header.discount_amount > 0 && (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between',
              margin: '2px 0'
            }}>
              <span>(-) Discount</span>
              <span></span>
              <span style={{ fontWeight: '800' }}>{parseFloat(billData.header.discount_amount).toFixed(2)}</span>
            </div>
          )}
          
          {/* Tax breakdown */}
          {/* {billData.header.tax_amount > 0 && (
            <div style={{ marginLeft: '20px', fontSize: '10px', color: '#666' }}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between',
                margin: '2px 0'
              }}>
                <span>CGST @ 14.00%</span>
                <span></span>
                <span>₹{(parseFloat(billData.header.tax_amount)/2).toFixed(2)}</span>
              </div>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between',
                margin: '2px 0'
              }}>
                <span>SGST @ 14.00%</span>
                <span></span>
                <span>₹{(parseFloat(billData.header.tax_amount)/2).toFixed(2)}</span>
              </div>
              {billData.header.cleaning_charge > 0 && (
                <>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    margin: '2px 0'
                  }}>
                    <span>CGST @ 2.50%</span>
                    <span></span>
                    <span>₹0.00</span>
                  </div>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    margin: '2px 0'
                  }}>
                    <span>SGST @ 2.50%</span>
                    <span></span>
                    <span>₹0.00</span>
                  </div>
                </>
              )}
            </div>
          )} */}
          
          {/* Total */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            fontWeight: '900',
            margin: '8px 0',
            padding: '6px 0',
            fontSize: '12px',
            borderTop: '2px solid #000',
            borderBottom: '2px solid #000'
          }}>
            <span>TOTAL</span>
            <span></span>
            <span>₹{parseFloat(billData.header.grand_total).toFixed(2)}</span>
          </div>
        </div>
        
        {/* Payment section */}
        <div style={{ fontSize: '11px', fontWeight: '700', margin: '8px 0' }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            margin: '2px 0'
          }}>
            <span>{billData.header.payment_mode || 'Not Paid'} :</span>
            <span></span>
            <span>₹{parseFloat(billData.header.grand_total).toFixed(2)}</span>
          </div>
          {/* <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            margin: '2px 0'
          }}>
            <span>Cash tendered:</span>
            <span></span>
            <span>₹{parseFloat(billData.header.grand_total).toFixed(2)}</span>
          </div> */}
        </div>
        
        {/* Footer */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '15px', 
          paddingTop: '8px',
          borderTop: '1px dashed #000',
          fontSize: '9px',
          fontWeight: '600',
          color: '#555'
        }}>
          Thank you for your visit! Please come again!
        </div>
      </div>
    ) : (
      <div className="text-center py-4">
        <p>Loading...</p>
      </div>
    )}
  </Modal.Body>

  <Modal.Footer className="border-0">
    <Button variant="outline-primary" size="sm" onClick={() => setShowBillModal(false)}>
      Close
    </Button>
    <Button variant="secondary" size="sm" onClick={handlePrint}>
      Print Receipt
    </Button>
  </Modal.Footer>
</Modal>


{/* Cutting Slip Modal - COMPACT VERSION */}
{/* Cutting Slip Modal - TABLE FORMAT */}
<Modal show={showCuttingSlipModal} onHide={() => setShowCuttingSlipModal(false)} size="md" centered>
  <Modal.Header closeButton style={{ background: '#fff3cd', borderBottom: '2px solid #ffb703', padding: '12px 16px' }}>
    <Modal.Title style={{ color: '#333', fontWeight: 800, fontSize: 16 }}>
      🔪 Cutting Instructions Slip
    </Modal.Title>
  </Modal.Header>
  
  <Modal.Body className="p-0">
    {cuttingSlipData && (
      <div id="cutting-slip-print" style={{ padding: 16, background: '#fff', fontSize: 12 }}>
        {/* Header - Updated to match invoice */}
        <div style={{ textAlign: 'center', marginBottom: 16, paddingBottom: 8 }}>
          {/* Company Name */}
          <div 
          className="hide-on-print"
          style={{ 
            fontWeight: 800, 
            fontSize: 18, 
            marginBottom: 4,
            color: '#000',
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            textDecoration: 'underline'
          }}>
            {/* ROYALS FISH PVT LTD */}
            Cutting Instructions
          </div>
          
       
        </div>

        {/* Bill Info - Compact */}
       <div style={{ marginBottom: 12, fontSize: 11, lineHeight: 1.6 }}>
  <div style={{ 
    display: 'flex', 
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px'
  }}>
    <div style={{ flex: 1 }}>
      <strong>Bill No:</strong>
      <span style={{ color: '#d32f2f', fontWeight: 700, marginLeft: 4 }}>
        {cuttingSlipData.bill_number}
      </span>
    </div>
    
    <div style={{ flex: 1, textAlign: 'right' }}>
      <strong>Date & Time:</strong>
      <span style={{ marginLeft: 4 }}>{cuttingSlipData.date_time}</span>
    </div>
  </div>
</div>


 
  <div >
    <div>
      <strong>Customer Name:</strong>
      <span style={{ color: '#d32f2f', fontWeight: 700, marginLeft: 4 }}>
        {cuttingSlipData.customer_name}
      </span>
    </div>

</div>
        {/* <hr style={{ border: 'none', height: 2, background: '#000', margin: '8px 0' }} /> */}

        {/* ✅ TABLE FORMAT */}
        <table style={{ 
          width: '100%', 
          borderCollapse: 'none',
          marginTop: 10,
          fontSize: 11
        }}>
          <thead>
            <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #000', borderTop: '2px solid #000' }}>
              <th style={{ 
                padding: '8px 6px', 
                textAlign: 'left', 
                fontWeight: 800,
                fontSize: 11,
                width: '8%'
              }}>#</th>
              <th style={{ 
                padding: '8px 6px', 
                textAlign: 'left', 
                fontWeight: 800,
                fontSize: 11,
                width: '10%'
              }}>Code</th>
              <th style={{ 
                padding: '8px 6px', 
                textAlign: 'left', 
                fontWeight: 800,
                fontSize: 11,
                width: '32%'
              }}>Item</th>
              <th style={{ 
                padding: '8px 6px', 
                textAlign: 'center', 
                fontWeight: 800,
                fontSize: 11,
                width: '15%'
              }}>Qty</th>
              <th style={{ 
                padding: '8px 6px', 
                textAlign: 'left', 
                fontWeight: 800,
                fontSize: 11,
                width: '35%'
              }}>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {cuttingSlipData.items.map((item, idx) => (
              <tr key={idx} 
              // style={{ borderBottom: '1px solid #dee2e6' }}
              >
                {/* S.No */}
                <td style={{ 
                  padding: '7px 4px', 
                  fontWeight: 800,
                  fontSize: 13,
                  color: '#d32f2f',
                  // verticalAlign: 'top',
                  fontWeight: 700
                }}>
                  {idx + 1}
                </td>

                {/* Code */}
                <td style={{ 
                  padding: '7px 4px',
                  fontSize: 13,
                  fontWeight: 800,
                  color: '#333',
                  // verticalAlign: 'top'
                }}>
                  {item.cutting_code || '0'}
                </td>

                {/* Item Details */}
                <td style={{ padding: '7px 4px' }}>
                  <div style={{ fontWeight: 700, fontSize: 12, color: '#111', marginBottom: 2 }}>
                    {item.product_name}
                  </div>
                  {/* <div style={{ fontSize: 10, color: '#666', marginBottom: 3, fontWeight: 800 }}>
                    {item.gross_weight}{item.uom}
                  </div>
                  <div style={{ 
                    fontWeight: 800, 
                    fontSize: 11, 
                    color: '#d32f2f',
                    background: '#fff3cd',
                    padding: '2px 6px',
                    borderRadius: 3,
                    display: 'inline-block'
                  }}>
                    🔪 {item.cutting_name}
                  </div> */}
                </td>

                {/* Quantity */}
                <td style={{ 
                  padding: '7px 4px', 
                  textAlign: 'center'
                }}>
                  <div style={{ 
                    color: 'black', 
                    padding: '6px 10px', 
                    borderRadius: 5,
                    fontWeight: 800,
                    fontSize: 12
                  }}>
                    {item.qty} KG
                  </div>
                </td>

                {/* Instructions */}
                <td style={{ 
                  padding: '7px 4px',
                  fontSize: 10,
                  color: '#333',
                  lineHeight: 1.4,
                  fontWeight: 700
                }}>
                  {item.cutting_info || '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* <hr style={{ border: 'none', height: 2, background: '#000', margin: '10px 0' }} /> */}

        {/* Footer - Summary */}
        <div style={{ marginTop: 3 }}>
  <div style={{ 
    display: 'flex', 
    justifyContent: 'space-between',
    fontSize: 11,
    fontWeight: 700,
    padding: '6px 0',
    borderTop: '2px solid #000'
  }}>
    <div style={{ flex: 1 }}>
      <span>Total Items:</span>
      <span style={{ marginLeft: 4 }}>{cuttingSlipData.items.length}</span>
    </div>
    
    <div style={{ flex: 1, textAlign: 'right' }}>
      <span>Total Quantity:</span>
      <span style={{ marginLeft: 4 }}>
        {cuttingSlipData.items.reduce((sum, item) => sum + item.qty, 0)} KG
      </span>
    </div>
  </div>
</div>
        {/* Footer - User */}
        {/* <div style={{ textAlign: 'center', marginTop: 12, paddingTop: 8, borderTop: '1px dashed #999' }}>
          <div style={{ fontSize: 9, color: '#999' }}>
            Prepared By: {localStorage.getItem("user_name") || "Admin"}
          </div>
        </div> */}
      </div>
    )}
  </Modal.Body>

  <Modal.Footer style={{ borderTop: '2px solid #ffb703', padding: '10px 16px' }}>
    <Button 
      variant="outline-danger" 
      size="sm"
      onClick={() => setShowCuttingSlipModal(false)}
    >
      Cancel
    </Button>
    <Button 
      variant="warning" 
      size="sm"
      onClick={handlePrintCuttingSlip}
      style={{ fontWeight: 700 }}
    >
      🖨️ Print
    </Button>
    <Button 
      variant="secondary" 
      size="sm"
      onClick={async () => {
        setShowCuttingSlipModal(false);
        await processBilling();
      }}
      style={{ fontWeight: 700 }}
    >
      ✅ Proceed to Bill
    </Button>
  </Modal.Footer>
</Modal>

{/* Hold Orders Modal */}
<Modal show={showHoldOrdersModal} onHide={() => setShowHoldOrdersModal(false)} size="lg" centered>
  <Modal.Header closeButton>
    <Modal.Title>Hold Orders - {selectedCustomer?.name}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {loadingHoldOrders ? (
      <div className="text-center py-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    ) : holdOrders.length === 0 ? (
      <div className="text-center py-4 text-muted">
        No hold orders found for this customer.
      </div>
    ) : (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {holdOrders.map((order, idx) => (
          <div 
            key={order.id} 
            style={{ 
              border: '1px solid #e0e0e0', 
              borderRadius: 8, 
              padding: 14,
              background: '#f9f9f9',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = '#f0f0f0'}
            onMouseLeave={(e) => e.currentTarget.style.background = '#f9f9f9'}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 14, color: '#333' }}>
                  Order #{idx + 1}
                </div>
                <div style={{ fontSize: 12, color: '#666' }}>
                  {new Date(order.created_at).toLocaleString()}
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 16, fontWeight: 800, color: '#16a34a' }}>
                  ₹{parseFloat(order.grand_total).toFixed(2)}
                </div>
                <div style={{ fontSize: 11, color: '#666' }}>
                  {order.total_items} items, {order.total_qty} qty
                </div>
              </div>
            </div>

            <div style={{ 
              background: '#fff', 
              padding: 8, 
              borderRadius: 6, 
              marginBottom: 10,
              maxHeight: 150,
              overflowY: 'auto'
            }}>
              {order.details.map((detail, dIdx) => (
                <div key={dIdx} style={{ 
                  fontSize: 12, 
                  padding: '4px 0',
                  borderBottom: dIdx < order.details.length - 1 ? '1px solid #f0f0f0' : 'none'
                }}>
                  <div style={{ fontWeight: 600 }}>
                    {detail.product_name} × {detail.qty}
                  </div>
                  {detail.cuttings && detail.cuttings.length > 0 && (
                    <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>
                      Cuttings: {detail.cuttings.map(c => `${c.cutting_name} (${c.qty})`).join(', ')}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', gap: 8 }}>
              <button
                onClick={() => loadHoldOrder(order)}
                style={{
                  flex: 1,
                  padding: '8px 16px',
                  borderRadius: 6,
                  background: '#0d6efd',
                  color: '#fff',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 600,
                  fontSize: 13
                }}
              >
                Load Order
              </button>
            </div>
          </div>
        ))}
      </div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowHoldOrdersModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

{/* Create Customer Modal */}
<Modal show={showCreateCustomerModal} onHide={() => setShowCreateCustomerModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Create New Customer?</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <p>Phone <strong>{customerPhoneSearch}</strong>. Create a new customer with this phone?</p>
    <div style={{ marginBottom: 12 }}>
      <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 6 }}>Phone Number</label>
      <input type="text" value={customerPhoneSearch} onChange={(e) => setCustomerPhoneSearch(e.target.value)} placeholder="Enter phone number" style={{ width: '100%', padding: '8px', borderRadius: 6, border: '1px solid #e9e9e9' }} />
    </div>
    <div>
      <label style={{ fontSize: 13, fontWeight: 600, display: 'block', marginBottom: 6 }}>Customer Name</label>
      <input value={newCustomerName} onChange={(e) => setNewCustomerName(e.target.value)} placeholder="Enter customer name" style={{ width: '100%', padding: '8px', borderRadius: 6, border: '1px solid #e9e9e9' }} />
    </div>
    <div style={{ marginTop: 12 }}>
  <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 6 }}>
    Date of Birth
  </label>
  <input
    type="date"
    value={dob}
    onChange={(e) => setDob(e.target.value)}
    style={{
      width: "100%",
      padding: "8px",
      borderRadius: 6,
      border: "1px solid #e9e9e9",
    }}
  />
</div>

<div style={{ marginTop: 12 }}>
  <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 6 }}>
    Anniversary
  </label>
  <input
    type="date"
    value={anniversary}
    onChange={(e) => setAnniversary(e.target.value)}
    style={{
      width: "100%",
      padding: "8px",
      borderRadius: 6,
      border: "1px solid #e9e9e9",
    }}
  />
</div>

<div style={{ marginTop: 12 }}>
  <label
    style={{
      fontSize: 13,
      fontWeight: 600,
      display: "block",
      marginBottom: 6,
    }}
  >
    Full Address
  </label>

  <Form.Control
    as="textarea"
    value={fullAddress}
    onChange={(e) => setFullAddress(e.target.value)}
    placeholder="Enter full address"
    rows={3}
    style={{
      width: "100%",
      padding: "8px",
      borderRadius: 6,
      border: "1px solid #e9e9e9",
      resize: "none",
    }}
  />
</div>


<div style={{ marginTop: 12 }}>
  <label
    style={{
      fontSize: 13,
      fontWeight: 600,
      display: "block",
      marginBottom: 6,
    }}
  >
    Remarks
  </label>

  <Form.Control
    as="textarea"
    value={remarks}
    onChange={(e) => setRemarks(e.target.value)}
    placeholder="Enter remarks"
    rows={2}
    style={{
      width: "100%",
      padding: "8px",
      borderRadius: 6,
      border: "1px solid #e9e9e9",
      resize: "none",
    }}
  />
</div>

  </Modal.Body>
  <Modal.Footer>
    <Button variant="primary" size="lg" onClick={() => setShowCreateCustomerModal(false)}>Cancel</Button>
    <Button variant="secondary" size="lg" onClick={createCustomerFromModal}>Create & proceed</Button>
  </Modal.Footer>
</Modal>


{/* Cutting Styles Modal */}
<Modal show={showCuttingModal} onHide={() => setShowCuttingModal(false)} centered size="xl">
  <Modal.Header closeButton>
    <Modal.Title>Choose Cutting Style</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div style={{ textAlign: 'center', marginBottom: 16 }}>
      <div style={{ fontSize: 14, fontWeight: 600, color: '#333', marginBottom: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
        <span>{cuttingForProduct?.product_name}</span>
        {cart.filter(item => 
          String(item.product_id) === String(cuttingForProduct?.product_id || cuttingForProduct?.id || cuttingForProduct?.veemart_product_id)
        ).length > 0 && (
          <span style={{ 
            background: 'red', 
            color: '#fff', 
            padding: '4px 10px', 
            borderRadius: 6,
            fontSize: 13,
            fontWeight: 700
          }}>
            Total Qty: {" "}
            {cuttingForProduct?.qty}
             {/* {cart
              .filter(item => String(item.product_id) === String(cuttingForProduct?.product_id || cuttingForProduct?.id || cuttingForProduct?.veemart_product_id))
              .reduce((sum, item) => sum + Number(item.qty || 0), 0)
            } */}
          </span>
        )}

         <Button 
        variant="secondary" 
        size="sm" 
        onClick={() => {
    const totalCuttingQty = getTotalCuttingQty();
    const productQty = Number(cuttingForProduct?.qty || 0);

    if (totalCuttingQty !== productQty) {
      toast.error(
        `Cutting qty mismatch! Selected: ${totalCuttingQty}, Required: ${productQty}`
      );
      return; // ❌ stop closing modal
    }

    // ✅ Qty matches → close modal
    setShowCuttingModal(false);
    setCuttingForProduct(null);
  }}
      >
        Done
      </Button>
      </div>
      <div style={{ fontSize: 13, color: '#6b7280' }}>
        Select multiple cutting styles with quantities
      </div>
    </div>

     {/* Summary of selected cuttings */}
  {cart.filter(item => 
     String(item.product_id) === String(cuttingForProduct?.product_id || cuttingForProduct?.id)
  && item.cutting_id
  ).length > 0 && (
    <div style={{ 
      marginTop: 20, 
      padding: 12, 
      background: '#f8f9fa', 
      borderRadius: 8,
      border: '1px solid #e9ecef'
    }}>
      <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8, color: '#333' }}>
        Selected Cuttings:
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {cart
           .filter(item =>
    String(item.product_id) === String(cuttingForProduct?.product_id || cuttingForProduct?.id)
    && item.cutting_id
  )
          .map((item, idx) => (
            <div 
              key={idx}
              style={{ 
                fontSize: 12, 
                background: '#ffb703', 
                color: '#fff', 
                padding: '4px 10px', 
                borderRadius: 6,
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                gap: 6
              }}
            >
              {item.cutting_name} 
              <span style={{ 
                background: 'rgba(255,255,255,0.3)', 
                padding: '2px 6px', 
                borderRadius: 4 
              }}>×{item.qty}</span>
               <span style={{marginLeft:5, color:"red"}} onClick={() => handleRemoveCutting(item)}> <i className="fa fa-trash"></i></span>
             
            </div>
          ))
        }
      </div>
    </div>
  )}
  
  <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
    {cuttingStyles.length === 0 && (
      <div style={{ textAlign: 'center', color: '#999', padding: 20 }}>
        No cutting styles available.
      </div>
    )}
    
    {cuttingStyles.map((c) => {
      const baseId = cuttingForProduct?.product_id || cuttingForProduct?.id || cuttingForProduct?.veemart_product_id;
      const cuttingId = c.id || c.cut_id;
      
      const cartItem = cart.find(item => 
        String(item.product_id) === String(baseId) && 
        String(item.cutting_id) === String(cuttingId)
      );
      
      const currentQty = cartItem?.qty || 0;
      const isSelected = currentQty > 0;
      
      return (
        <div 
          key={cuttingId}
          style={{ 
            width: 180, 
            border: isSelected ? '3px solid #ffb703' : '1px solid #eee', 
            borderRadius: 10, 
            padding: 10, 
            textAlign: 'center',
            background: isSelected ? '#fffbeb' : '#fff',
            boxShadow: isSelected ? '0 4px 12px rgba(255, 183, 3, 0.3)' : '0 2px 6px rgba(0,0,0,0.05)',
            transition: 'all 0.2s ease',
            position: 'relative',
            marginTop: 10
          }}
        >
          {isSelected && (
            <div style={{ 
              position: 'absolute', 
              top: 6, 
              right: 6, 
              background: '#ffb703', 
              borderRadius: '50%', 
              width: 26, 
              height: 26, 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              color: '#fff',
              fontWeight: 'bold',
              fontSize: 14,
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
            }}>✓</div>
          )}
          
          <img 
            src={c.cutting_image ? `${image_api}${String(c.cutting_image).replace(/^test\//, '')}` : defaultImg} 
            alt={c.cutting_name} 
            style={{ 
              width: '100%', 
              height: 100, 
              objectFit: 'cover', 
              borderRadius: 8,
              marginBottom: 8
            }} 
          />
          
          <div style={{ fontWeight: 700, fontSize: 13, color: isSelected ? '#ffb703' : '#333', marginBottom: 4 }}>
            {c.cutting_name || c.cut_name || c.name}
          </div>
          
          <div style={{ fontSize: 11, color: '#666', marginBottom: 10 }}>
            Code: {c.cutting_code || c.code || c.cut_code}
          </div>
          
          {/* Quantity Input */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            gap: 8,
            background: '#f8f9fa',
            padding: '6px 10px',
            borderRadius: 6,
            marginBottom: 8
          }}>
            <label style={{ fontSize: 12, color: '#666', fontWeight: 600 }}>Qty:</label>
           <input 
  type="number" 
  min="0"
  value={currentQty === 0 ? "" : currentQty}
  onChange={(e) => {
    const qty = Number(e.target.value) || 0;
    
    if (qty === 0) {
      setCart(cur => cur.filter(item => 
        !(String(item.product_id) === String(baseId) && 
          String(item.cutting_id) === String(cuttingId))
      ));
      toast.info('Cutting removed');
    } else {
      // ✅ FIX: Use immediate state update instead of function call
      setCart(cur => {
        const existingItem = cur.find(item => 
          String(item.product_id) === String(baseId) && 
          String(item.cutting_id) === String(cuttingId)
        );
        
        if (existingItem) {
          // Update existing item
          return cur.map(item =>
            (String(item.product_id) === String(baseId) && 
             String(item.cutting_id) === String(cuttingId))
              ? { ...item, qty }
              : item
          );
        } else {
          // Add new item
          const displayName = cuttingForProduct?.variant_name || cuttingForProduct?.product_name;
          const sellingPrice = cuttingForProduct?.final_selling_price || cuttingForProduct?.unit_price || cuttingForProduct?.price || 0;
          const unitPrice = cuttingForProduct?.unit_price || cuttingForProduct?.final_selling_price || cuttingForProduct?.price || 0;
          
          return [...cur, {
            product_id: baseId,
            product_name: displayName,
            final_selling_price: Number(sellingPrice),
            unit_price: Number(unitPrice),
            business_profit: cuttingForProduct?.business_profit || null,
            product_image: cuttingForProduct?.variant_image || cuttingForProduct?.product_image,
            uniqueId: `${baseId}-${cuttingId}`,
            id: `${baseId}-${cuttingId}`,
            variant_id: cuttingForProduct?.variant_id || (cuttingForProduct?.variant_name ? cuttingForProduct?.id : null),
            variant_name: cuttingForProduct?.variant_name || null,
            cutting_id: cuttingId,
            cutting_name: c.cutting_name || c.cut_name || c.name,
            cutting_image: c.cutting_image,
            cutting_code: c.cutting_code || c.code || c.cut_code,
            cutting_info: '',
            gross_weight: cuttingForProduct?.gross_weight || null,
            uom: cuttingForProduct?.uom || null,
            qty: qty,
          }];
        }
      });
      
      if (!isSelected) {
        toast.success(`${c.cutting_name} added`);
      }
    }
  }}
  onClick={(e) => e.stopPropagation()}
  style={{ 
    width: 90, 
    padding: '6px 8px', 
    borderRadius: 6, 
    border: '1px solid #d9d9d9', 
    fontSize: 13,
    textAlign: 'center',
    fontWeight: 600
  }} 
/>
          </div>

          {/* ✅ Cutting Instructions Textarea */}
          {isSelected && (
            <div style={{ marginTop: 8 }}>
              <textarea
                placeholder="Enter Remarks..."
                value={cartItem?.cutting_info || ''}
                onChange={(e) => {
                  const instruction = e.target.value;
                  setCart(cur => cur.map(item =>
                    (String(item.product_id) === String(baseId) && 
                     String(item.cutting_id) === String(cuttingId))
                      ? { ...item, cutting_info: instruction }
                      : item
                  ));
                }}
                onClick={(e) => e.stopPropagation()}
                style={{
                  width: '100%',
                  minHeight: 50,
                  padding: '6px 8px',
                  borderRadius: 6,
                  border: '1px solid #d9d9d9',
                  fontSize: 11,
                  resize: 'vertical',
                  fontFamily: 'inherit'
                }}
              />
            </div>
          )}
        </div>
      );
    })}
  </div>
  
 
</Modal.Body>
  <Modal.Footer>
  <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <div style={{ fontSize: 13, color: '#666' }}>
      {cart.filter(item => 
        String(item.product_id) === String(cuttingForProduct?.product_id || cuttingForProduct?.id)
      ).length} cutting(s) selected
    </div>
    <div style={{ display: 'flex', gap: 8 }}>
      {/* <Button 
        variant="outline-danger" 
        size="sm" 
        onClick={() => {
          // Add to cart without cutting
          if (cuttingForProduct) {
            addToCart(cuttingForProduct, null, null);
            toast.success(`${cuttingForProduct.product_name || cuttingForProduct.variant_name} added without cutting!`);
          }
          setShowCuttingModal(false);
          setCuttingForProduct(null);
        }}
      >
        Skip Cutting & Add
      </Button> */}
     
    </div>
  </div>
</Modal.Footer>
</Modal>


<Modal
  show={showPaymodeModal}
  onHide={() => setShowPaymodeModal(false)}
  centered
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>Payment Settlement</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {currentOrderInfo && (() => {

      const grandTotal = Number(currentOrderInfo.grand_total || 0);

      const totalPaid = paymodeEntries.reduce(
        (s, r) => s + Number(r.amount || 0),
        0
      );

      // 🔴 Customer → Owner (header balance)
      const balanceToOwner = grandTotal - totalPaid;

      return (
        <>
          {/* ===== HEADER INFO ===== */}
          <div className="p-3 mb-3 bg-light rounded">

            <Row className="mb-2">
              <Col md={6}>
                <strong>Customer:</strong> {currentOrderInfo.customer_name}
              </Col>
              <Col md={6}>
                <strong>Mobile:</strong> {currentOrderInfo.customer_mobile}
              </Col>
            </Row>

            <Row className="text-center">
              <Col md={6}>
                <div style={{ fontSize: 18, fontWeight: 700 }}>
                  Grand Total
                </div>
                <div style={{ fontSize: 26, fontWeight: 800 }}>
                  ₹ {grandTotal.toFixed(2)}
                </div>
              </Col>

              <Col md={6}>
                <div style={{ fontSize: 18, fontWeight: 700 }}>
                  Balance (Customer → Owner)
                </div>
                <div
                  style={{
                    fontSize: 26,
                    fontWeight: 800,
                    color: balanceToOwner > 0 ? "red" : "green"
                  }}
                >
                  ₹ {balanceToOwner.toFixed(2)}
                </div>
              </Col>
            </Row>
          </div>

          {/* ===== PAYMODE ROWS ===== */}
          <Row>
            {paymodeEntries.map((row, idx) => (
              <Col md={12} key={row.paymode_id} className="mb-2">
                <div className="p-3 border rounded bg-white">

                  <div className="d-flex align-items-center">
                    <div style={{ width: "35%", fontWeight: 700 }}>
                      {row.paymode_name}
                    </div>

                    <div style={{ width: "65%" }}>
                      <input
                        type="number"
                        className="form-control"
                        placeholder={`Enter ${row.paymode_name} amount`}
                        value={row.amount}
                        onChange={(e) => {

                          const copy = [...paymodeEntries];
                          copy[idx].amount = e.target.value;

                          // reset refund
                          copy.forEach(p => p.refund_amount = 0);

                          const paid = copy.reduce(
                            (s, r) => s + Number(r.amount || 0),
                            0
                          );

                          const refund = paid - grandTotal;

                          // 🔁 Owner → Customer (assign refund to THIS paymode)
                          if (refund > 0) {
                            copy[idx].refund_amount = refund;
                          }

                          setPaymodeEntries(copy);
                        }}
                      />

                      {/* 🔁 OWNER → CUSTOMER */}
                      {Number(row.refund_amount) > 0 && (
                        <div
                          style={{
                            marginTop: 6,
                            fontSize: 13,
                            fontWeight: 700,
                            color: "green"
                          }}
                        >
                          Refund to Customer: ₹ {row.refund_amount.toFixed(2)}
                        </div>
                      )}
                    </div>
                  </div>

                </div>
              </Col>
            ))}
          </Row>
        </>
      );
    })()}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowPaymodeModal(false)}>
      Cancel
    </Button>

   <Button
  variant="success"
  onClick={handleSubmitPaymode}
  disabled={
    paymodeEntries.reduce(
      (s, r) => s + Number(r.amount || 0),
      0
    ) < Number(currentOrderInfo?.grand_total || 0)
  }
>
  Submit Payment
</Button>

  </Modal.Footer>
</Modal>





{showSubModal && (
  <div className="subscription-overlay">
    <div className="subscription-modal">

      <FaRupeeSign size={40} color="#dc3545" />

      <h4 className="mt-3">
        {subMessageOnly
          ? "Subscription Not Available"
          : "Subscription Payment Pending"}
      </h4>

      <p className="text-muted mt-2">
        {subMessageOnly
          ? "This month you are not subscribed. Please contact admin."
          : "You did not pay subscription for this month. Please pay to continue."}
      </p>

      <div className="d-flex justify-content-center gap-2 mt-3">
      {!subMessageOnly && (
        <button
          className="btn btn-secondary mt-3"
          onClick={handlePayNow}
        >
          Pay Now
        </button>
      )}

      {/* ⚪ Maybe Later / Close */}
        <button
          className="btn btn-outline-danger mt-3"
          onClick={() => setShowSubModal(false)}
        >
          Maybe Later
        </button>
      </div>
    </div>
  </div>
)}

 <style>
      {`
      .subscription-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.subscription-modal {
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  width: 400px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}
`}
    </style>
    </div>
  );
};

export default WarehousePOS;






